// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteAccessDeleteData, DeleteAccessDeleteResponses, DeleteAiAgentsDeleteAgentData, DeleteAiAgentsDeleteAgentResponses, DeleteAiAgentsDeleteTestSessionData, DeleteAiAgentsDeleteTestSessionResponses, DeleteAllowlistDeleteEntryData, DeleteAllowlistDeleteEntryResponses, DeleteBlocklistDeleteBan2Data, DeleteBlocklistDeleteBan2Responses, DeleteBlocklistDeleteBanData, DeleteBlocklistDeleteBanResponses, DeleteByocAccountsRemoveData, DeleteByocAccountsRemoveResponses, DeleteCallerRoutesRemoveData, DeleteCallerRoutesRemoveResponses, DeleteCallFlowConfigsDeleteConfigData, DeleteCallFlowConfigsDeleteConfigResponses, DeleteCatalogAdminDeleteItemData, DeleteCatalogAdminDeleteItemResponses, DeleteCatalogAdminDeletePriceData, DeleteCatalogAdminDeletePriceResponses, DeleteCatalogAdminDeleteRelationData, DeleteCatalogAdminDeleteRelationResponses, DeleteEndpointConfigsDeleteConfigurationData, DeleteEndpointConfigsDeleteConfigurationResponses, DeleteEndpointsDetachAdditionalExtensionData, DeleteEndpointsDetachAdditionalExtensionResponses, DeleteExtensionsDeleteExtensionData, DeleteExtensionsDeleteExtensionResponses, DeleteGreetingsDeleteGreetingData, DeleteGreetingsDeleteGreetingResponses, DeleteHoldMusicDeleteHoldMusicData, DeleteHoldMusicDeleteHoldMusicResponses, DeleteMspOrdersDeleteDraftData, DeleteMspOrdersDeleteDraftResponses, DeleteNumbersDeleteData, DeleteNumbersDeleteResponses, DeleteOutboundRoutesDeleteRouteData, DeleteOutboundRoutesDeleteRouteResponses, DeleteParkingLotsDeleteLotData, DeleteParkingLotsDeleteLotResponses, DeleteRingGroupsDeleteGroupData, DeleteRingGroupsDeleteGroupResponses, DeleteSaByocNumbersRemoveData, DeleteSaByocNumbersRemoveResponses, DeleteSaTenantByocAccountsRemoveData, DeleteSaTenantByocAccountsRemoveResponses, DeleteSmsTelnyxRegistrationsAdminDeleteCampaignRegistrationTemplateData, DeleteSmsTelnyxRegistrationsAdminDeleteCampaignRegistrationTemplateResponses, DeleteSubscribedNumbersDeleteData, DeleteSubscribedNumbersDeleteResponses, DeleteTenantOverviewCancelNumberIntentData, DeleteTenantOverviewCancelNumberIntentResponses, DeleteTimeConditionsClearOverrideData, DeleteTimeConditionsClearOverrideResponses, DeleteTimeConditionsDeleteConditionData, DeleteTimeConditionsDeleteConditionResponses, DeleteVoicemailDeleteMessageData, DeleteVoicemailDeleteMessageResponses, DeleteWorkstationExtensionLinksClearData, DeleteWorkstationExtensionLinksClearResponses, GetAccessGetCompositeData, GetAccessGetCompositeResponses, GetAccessIndexData, GetAccessIndexResponses, GetAdminHardwareOrdersGetData, GetAdminHardwareOrdersGetResponses, GetAdminHardwareOrdersListData, GetAdminHardwareOrdersListResponses, GetAdminSignupOrdersListData, GetAdminSignupOrdersListResponses, GetAiAgentsGetAgentData, GetAiAgentsGetAgentResponses, GetAiAgentsGetCapabilitiesData, GetAiAgentsGetCapabilitiesResponses, GetAiAgentsGetTestSessionData, GetAiAgentsGetTestSessionResponses, GetAiAgentsListAgentsData, GetAiAgentsListAgentsResponses, GetAllowlistListEntriesData, GetAllowlistListEntriesResponses, GetBlocklistGetBan2Data, GetBlocklistGetBan2Responses, GetBlocklistGetBanData, GetBlocklistGetBanResponses, GetBlocklistListBansData, GetBlocklistListBansResponses, GetByocAccountsAvailableNumbersData, GetByocAccountsAvailableNumbersResponses, GetByocAccountsGetData, GetByocAccountsGetResponses, GetByocAccountsListData, GetByocAccountsListResponses, GetByocNumberConfigsGetData, GetByocNumberConfigsGetResponses, GetCallerRoutesGetData, GetCallerRoutesGetResponses, GetCallerRoutesListData, GetCallerRoutesListResponses, GetCallFlowConfigsGetConfigData, GetCallFlowConfigsGetConfigResponses, GetCallFlowConfigsListConfigsData, GetCallFlowConfigsListConfigsResponses, GetCallFlowConfigsListHistoryData, GetCallFlowConfigsListHistoryResponses, GetCallResearchDiagnosticsData, GetCallResearchDiagnosticsResponses, GetCallResearchOverviewData, GetCallResearchOverviewResponses, GetCallResearchQualityData, GetCallResearchQualityResponses, GetCallResearchSipData, GetCallResearchSipResponses, GetCarrierNumberBarnVanityNumbersData, GetCarrierNumberBarnVanityNumbersResponses, GetCarrierTelnyxEmergencyAddressesListData, GetCarrierTelnyxEmergencyAddressesListResponses, GetCarrierTelnyxNumbersAvailableNumbersData, GetCarrierTelnyxNumbersAvailableNumbersResponses, GetCatalogAdminGetData, GetCatalogAdminGetResponses, GetCatalogAdminListData, GetCatalogAdminListResponses, GetCdrDetailData, GetCdrDetailResponses, GetCdrGetData, GetCdrGetPageData, GetCdrGetPageResponses, GetCdrGetResponses, GetCdrLiveData, GetCdrLiveListData, GetCdrLiveListResponses, GetCdrLiveResponses, GetCdrOutcomesData, GetCdrOutcomesResponses, GetCdrRecordingGetMetaData, GetCdrRecordingGetMetaResponses, GetCdrRecordingGetPreparedRecordingContentData, GetCdrRecordingGetPreparedRecordingContentResponses, GetEndpointConfigsGetConfigurationData, GetEndpointConfigsGetConfigurationResponses, GetEndpointConfigsListConfigurationsData, GetEndpointConfigsListConfigurationsResponses, GetEndpointRemoteLoggingGetLogsData, GetEndpointRemoteLoggingGetLogsResponses, GetEndpointRemoteLoggingGetRemoteLoggingData, GetEndpointRemoteLoggingGetRemoteLoggingResponses, GetEndpointsGetEndpointData, GetEndpointsGetEndpointResponses, GetEndpointsGetResolvedConfigData, GetEndpointsGetResolvedConfigResponses, GetEndpointsListEndpointsData, GetEndpointsListEndpointsResponses, GetExtensionsListDetailedExtensionsData, GetExtensionsListDetailedExtensionsResponses, GetExtensionsListExtensionsData, GetExtensionsListExtensionsResponses, GetExtensionsListPlanTypesData, GetExtensionsListPlanTypesResponses, GetFaxesGetFaxData, GetFaxesGetFaxResponses, GetFaxesListFaxesData, GetFaxesListFaxesResponses, GetFirewallAuditListAuditData, GetFirewallAuditListAuditResponses, GetFpbxRegistrationsGetRegistrationsData, GetFpbxRegistrationsGetRegistrationsResponses, GetGreetingsGetContentData, GetGreetingsGetContentResponses, GetGreetingsListGreetingsData, GetGreetingsListGreetingsResponses, GetHoldMusicGetContentData, GetHoldMusicGetContentResponses, GetHoldMusicListHoldMusicData, GetHoldMusicListHoldMusicResponses, GetMediaPlaybackGetData, GetMediaPlaybackGetResponses, GetMspOrdersGetData, GetMspOrdersGetResponses, GetMspOrdersListData, GetMspOrdersListResponses, GetNumbersListData, GetNumbersListResponses, GetOrdersSignupGetAgreementData, GetOrdersSignupGetAgreementResponses, GetOrdersSignupGetOrderData, GetOrdersSignupGetOrderResponses, GetOutboundRoutesGetRouteData, GetOutboundRoutesGetRouteResponses, GetOutboundRoutesListRoutesData, GetOutboundRoutesListRoutesResponses, GetParkingLotsGetLotCallsData, GetParkingLotsGetLotCallsResponses, GetParkingLotsGetLotData, GetParkingLotsGetLotResponses, GetParkingLotsListLotsData, GetParkingLotsListLotsResponses, GetPresenceSnapshotData, GetPresenceSnapshotResponses, GetPublicCatalogGetCatalogData, GetPublicCatalogGetCatalogResponses, GetReferencesListReferencesData, GetReferencesListReferencesResponses, GetReportsCallsByDateData, GetReportsCallsByDateResponses, GetReportsCallsByExtensionData, GetReportsCallsByExtensionResponses, GetReportsCallsByNumberData, GetReportsCallsByNumberResponses, GetReportsFaxByDateData, GetReportsFaxByDateResponses, GetReportsFaxByNumberData, GetReportsFaxByNumberResponses, GetReportsSmsByDateData, GetReportsSmsByDateResponses, GetReportsSmsByNumberData, GetReportsSmsByNumberResponses, GetRingGroupsGetEffectiveMembersData, GetRingGroupsGetEffectiveMembersResponses, GetRingGroupsGetGroupData, GetRingGroupsGetGroupResponses, GetRingGroupsListGroupsData, GetRingGroupsListGroupsResponses, GetSaByocNumbersGetConfigData, GetSaByocNumbersGetConfigResponses, GetSaByocNumbersListData, GetSaByocNumbersListResponses, GetSaTalkRuntimeListRegistrationsData, GetSaTalkRuntimeListRegistrationsResponses, GetSaTalkRuntimeLiveCallsChangesData, GetSaTalkRuntimeLiveCallsChangesResponses, GetSaTalkRuntimeLiveCallsData, GetSaTalkRuntimeLiveCallsResponses, GetSaTalkTenantsGetData, GetSaTalkTenantsGetResponses, GetSaTalkTenantsListData, GetSaTalkTenantsListResponses, GetSaTenantByocAccountsGetData, GetSaTenantByocAccountsGetResponses, GetSaTenantByocAccountsListData, GetSaTenantByocAccountsListResponses, GetSmsBrandsGetData, GetSmsBrandsGetResponses, GetSmsBrandsListData, GetSmsBrandsListResponses, GetSmsBrandsVerticalsData, GetSmsBrandsVerticalsResponses, GetSmsConversationsGetConversationData, GetSmsConversationsGetConversationResponses, GetSmsConversationsGetMessagesData, GetSmsConversationsGetMessagesResponses, GetSmsConversationsListConversationsData, GetSmsConversationsListConversationsResponses, GetSmsRegistrationsAdminBrandData, GetSmsRegistrationsAdminBrandResponses, GetSmsRegistrationsAdminBrandsData, GetSmsRegistrationsAdminBrandsResponses, GetSmsRegistrationsAdminCampaignData, GetSmsRegistrationsAdminCampaignResponses, GetSmsRegistrationsAdminRequestsData, GetSmsRegistrationsAdminRequestsResponses, GetSmsTelnyxRegistrationsAdminBindingsData, GetSmsTelnyxRegistrationsAdminBindingsResponses, GetSmsTelnyxRegistrationsAdminBrandsData, GetSmsTelnyxRegistrationsAdminBrandsResponses, GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplateData, GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplateResponses, GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplatesData, GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplatesResponses, GetSmsTelnyxRegistrationsAdminCampaignsData, GetSmsTelnyxRegistrationsAdminCampaignsResponses, GetSmsTelnyxRegistrationsAdminCampaignUsecasesData, GetSmsTelnyxRegistrationsAdminCampaignUsecasesResponses, GetSubscribedNumbersIndexData, GetSubscribedNumbersIndexResponses, GetTalkAuditIndexData, GetTalkAuditIndexResponses, GetTenantGetTenantData, GetTenantGetTenantResponses, GetTenantHardwareOrdersCatalogData, GetTenantHardwareOrdersCatalogResponses, GetTenantHardwareOrdersGetData, GetTenantHardwareOrdersGetResponses, GetTenantHardwareOrdersListData, GetTenantHardwareOrdersListResponses, GetTenantHardwareOrdersUnlinkedDevicesData, GetTenantHardwareOrdersUnlinkedDevicesResponses, GetTenantOverviewGetData, GetTenantOverviewGetResponses, GetTenantUsageGetUsageData, GetTenantUsageGetUsageResponses, GetTimeConditionsGetConditionData, GetTimeConditionsGetConditionResponses, GetTimeConditionsGetStatusData, GetTimeConditionsGetStatusResponses, GetTimeConditionsListConditionsData, GetTimeConditionsListConditionsResponses, GetTtsRenderGetCatalogData, GetTtsRenderGetCatalogResponses, GetTtsRenderRenderData, GetTtsRenderRenderResponses, GetUploadsGetContentData, GetUploadsGetContentResponses, GetUploadsGetTranscriptionData, GetUploadsGetTranscriptionResponses, GetUploadsGetUrlData, GetUploadsGetUrlResponses, GetVoicemailGetAudioData, GetVoicemailGetAudioResponses, GetVoicemailGetCountsData, GetVoicemailGetCountsResponses, GetVoicemailGetInternalAudioData, GetVoicemailGetInternalAudioResponses, GetVoicemailGetTranscriptionData, GetVoicemailGetTranscriptionResponses, GetVoicemailIndexData, GetVoicemailIndexResponses, GetWorkstationExtensionLinksCurrentData, GetWorkstationExtensionLinksCurrentResponses, GetWorkstationExtensionLinksListData, GetWorkstationExtensionLinksListResponses, PatchAdminHardwareOrdersUpdateData, PatchAdminHardwareOrdersUpdateResponses, PatchAdminSignupOrdersUpdateBillingBypassData, PatchAdminSignupOrdersUpdateBillingBypassResponses, PatchMspOrdersUpdateExistingTenantData, PatchMspOrdersUpdateExistingTenantResponses, PatchOrdersSignupHandleUpdateDraftData, PatchOrdersSignupHandleUpdateDraftResponses, PostAccessNotifyAccessReconfiguredData, PostAccessNotifyAccessReconfiguredResponses, PostAccessStoreData, PostAccessStoreResponses, PostAdminHardwareOrdersPlaceData, PostAdminHardwareOrdersPlaceResponses, PostAdminSetConfigData, PostAdminSetConfigResponses, PostAdminSignupOrdersReprocessOrderData, PostAdminSignupOrdersReprocessOrderResponses, PostAdminSignupOrdersRetryFailedOrderData, PostAdminSignupOrdersRetryFailedOrderResponses, PostAiAgentsCreateAgentData, PostAiAgentsCreateAgentResponses, PostAiAgentsCreateTestSessionData, PostAiAgentsCreateTestSessionResponses, PostAiAgentsHeartbeatTestSessionData, PostAiAgentsHeartbeatTestSessionResponses, PostAiAgentsOptimizePromptData, PostAiAgentsOptimizePromptResponses, PostAllowlistCreateEntryData, PostAllowlistCreateEntryResponses, PostBillPlanAnalysisAnalyzeData, PostBillPlanAnalysisAnalyzeResponses, PostBlocklistCreateBanData, PostBlocklistCreateBanResponses, PostByocAccountsCreateData, PostByocAccountsCreateNumbersData, PostByocAccountsCreateNumbersResponses, PostByocAccountsCreateResponses, PostCallControlKillData, PostCallControlKillResponses, PostCallerRoutesCreateData, PostCallerRoutesCreateResponses, PostCallFlowConfigsCreateConfigData, PostCallFlowConfigsCreateConfigResponses, PostCallFlowConfigsRestoreHistoryData, PostCallFlowConfigsRestoreHistoryResponses, PostCarrierNumberBarnCreateVanityOrderData, PostCarrierNumberBarnCreateVanityOrderResponses, PostCarrierTelnyxEventHandleEventData, PostCarrierTelnyxEventHandleEventResponses, PostCarrierTelnyxNumbersAttachExistingNumberData, PostCarrierTelnyxNumbersAttachExistingNumberResponses, PostCarrierTelnyxNumbersCreateNumberOrderData, PostCarrierTelnyxNumbersCreateNumberOrderResponses, PostCarrierTelnyxNumbersCreatePortOrderData, PostCarrierTelnyxNumbersCreatePortOrderResponses, PostCarrierTelnyxNumbersDownloadPortOrderLoaTemplateData, PostCarrierTelnyxNumbersDownloadPortOrderLoaTemplateResponses, PostCarrierTelnyxNumbersPortabilityChecksData, PostCarrierTelnyxNumbersPortabilityChecksResponses, PostCatalogAdminCreateData, PostCatalogAdminCreateImageData, PostCatalogAdminCreateImageResponses, PostCatalogAdminCreateResponses, PostCatalogAdminPublishData, PostCatalogAdminPublishResponses, PostCatalogAdminValidateData, PostCatalogAdminValidateResponses, PostCatalogAdminValidateVendorSkuData, PostCatalogAdminValidateVendorSkuResponses, PostCdrDeclineData, PostCdrDeclineResponses, PostCdrIngestIngestData, PostCdrIngestIngestResponses, PostCdrRecordingGenerateAdHocSummaryData, PostCdrRecordingGenerateAdHocSummaryResponses, PostCdrRecordingGenerateRecordingData, PostCdrRecordingGenerateRecordingResponses, PostCdrRecordingGenerateSummaryData, PostCdrRecordingGenerateSummaryResponses, PostCdrRecordingGenerateTranscriptData, PostCdrRecordingGenerateTranscriptResponses, PostCdrRecordingRateSentimentData, PostCdrRecordingRateSentimentResponses, PostCdrRecordingRateSummaryData, PostCdrRecordingRateSummaryResponses, PostCdrSummaryExperimentGenerateAdHocSummaryFromTranscriptData, PostCdrSummaryExperimentGenerateAdHocSummaryFromTranscriptResponses, PostEndpointConfigsCreateConfigurationData, PostEndpointConfigsCreateConfigurationResponses, PostEndpointsAttachAdditionalExtensionData, PostEndpointsAttachAdditionalExtensionResponses, PostEndpointsCreateEndpointData, PostEndpointsCreateEndpointResponses, PostEndpointsProvisionEndpointData, PostEndpointsProvisionEndpointResponses, PostEndpointsRebootEndpointData, PostEndpointsRebootEndpointResponses, PostExtensionsCreateExtensionData, PostExtensionsCreateExtensionResponses, PostExtensionsValidateExtensionData, PostExtensionsValidateExtensionResponses, PostExtensionsValidatePlanChangeData, PostExtensionsValidatePlanChangeResponses, PostFaxesArchiveFaxData, PostFaxesArchiveFaxResponses, PostFaxesMarkFaxReadData, PostFaxesMarkFaxReadResponses, PostFaxesMarkFaxUnreadData, PostFaxesMarkFaxUnreadResponses, PostFaxesRetryFaxData, PostFaxesRetryFaxResponses, PostFaxesSendFaxData, PostFaxesSendFaxResponses, PostFaxesUnarchiveFaxData, PostFaxesUnarchiveFaxResponses, PostFaxesWebhookHandlePayloadData, PostFaxesWebhookHandlePayloadResponses, PostGrandstreamEndpointsGetRemoteWebUiUrlData, PostGrandstreamEndpointsGetRemoteWebUiUrlResponses, PostGrandstreamEndpointsGetScreenshotData, PostGrandstreamEndpointsGetScreenshotResponses, PostGreetingsCreateGreetingData, PostGreetingsCreateGreetingResponses, PostHoldMusicCreateHoldMusicData, PostHoldMusicCreateHoldMusicResponses, PostInboundFlowrouteSmsHandleData, PostInboundFlowrouteSmsHandleKeyedData, PostInboundFlowrouteSmsHandleKeyedResponses, PostInboundFlowrouteSmsHandleResponses, PostInboundSignalwireSmsHandleData, PostInboundSignalwireSmsHandleResponses, PostInboundTelnyxSmsHandleData, PostInboundTelnyxSmsHandleResponses, PostInboundTwilioSmsHandleData, PostInboundTwilioSmsHandleResponses, PostMspOrdersCreateData, PostMspOrdersCreateResponses, PostNumbersClearEmergencyStatusData, PostNumbersClearEmergencyStatusResponses, PostNumbersProvisionTemporaryNumberData, PostNumbersProvisionTemporaryNumberResponses, PostNumbersQueueTelnyxSyncData, PostNumbersQueueTelnyxSyncResponses, PostNumbersRefreshPortingData, PostNumbersRefreshPortingResponses, PostOrders888VoipHandleWebhookData, PostOrders888VoipHandleWebhookResponses, PostOrdersAdminProvisionHardwareData, PostOrdersAdminProvisionHardwareResponses, PostOrdersSignupHandleCompleteData, PostOrdersSignupHandleCompleteResponses, PostOrdersSignupHandleConfirmEmailVerificationData, PostOrdersSignupHandleConfirmEmailVerificationResponses, PostOrdersSignupHandleCreateDraftData, PostOrdersSignupHandleCreateDraftResponses, PostOrdersSignupHandleIssueEmailVerificationData, PostOrdersSignupHandleIssueEmailVerificationResponses, PostOrdersSignupHandlePaymentMethodData, PostOrdersSignupHandlePaymentMethodResponses, PostOrdersSignupHandlePrepareOrderData, PostOrdersSignupHandlePrepareOrderResponses, PostOrdersSignupHandleUpdatePaymentData, PostOrdersSignupHandleUpdatePaymentResponses, PostOrdersSignupValidateOrderData, PostOrdersSignupValidateOrderResponses, PostOrdersTeledynamicsHandleWebhookData, PostOrdersTeledynamicsHandleWebhookResponses, PostOutboundRoutesCreateRouteData, PostOutboundRoutesCreateRouteResponses, PostParkingLotsCreateLotData, PostParkingLotsCreateLotResponses, PostRingGroupsCreateGroupData, PostRingGroupsCreateGroupResponses, PostSaByocNumbersCreateData, PostSaByocNumbersCreateResponses, PostSaTenantByocAccountsCreateData, PostSaTenantByocAccountsCreateResponses, PostSignalwireSmsStatusHandleData, PostSignalwireSmsStatusHandleResponses, PostSimulatedInboundSmsReceiveData, PostSimulatedInboundSmsReceiveResponses, PostSmsBrandsCreateData, PostSmsBrandsCreateResponses, PostSmsConversationsArchiveConversationData, PostSmsConversationsArchiveConversationResponses, PostSmsConversationsContinueConversationData, PostSmsConversationsContinueConversationResponses, PostSmsConversationsMarkMessageReadData, PostSmsConversationsMarkMessageReadResponses, PostSmsConversationsMarkMessageUnreadData, PostSmsConversationsMarkMessageUnreadResponses, PostSmsConversationsNewConversationData, PostSmsConversationsNewConversationResponses, PostSmsConversationsUnarchiveConversationData, PostSmsConversationsUnarchiveConversationResponses, PostSmsTelnyxRegistrationsAdminCreateCampaignData, PostSmsTelnyxRegistrationsAdminCreateCampaignRegistrationTemplateData, PostSmsTelnyxRegistrationsAdminCreateCampaignRegistrationTemplateResponses, PostSmsTelnyxRegistrationsAdminCreateCampaignResponses, PostSmsTelnyxRegistrationsAdminMarkBrandProcessingData, PostSmsTelnyxRegistrationsAdminMarkBrandProcessingResponses, PostSmsTelnyxRegistrationsAdminRefreshBindingsData, PostSmsTelnyxRegistrationsAdminRefreshBindingsResponses, PostSmsTelnyxRegistrationsAdminSubmitBrandData, PostSmsTelnyxRegistrationsAdminSubmitBrandResponses, PostSmsTelnyxRegistrationsAdminSubmitCampaignRegistrationData, PostSmsTelnyxRegistrationsAdminSubmitCampaignRegistrationResponses, PostSoftphoneCallViaDeskPhoneData, PostSoftphoneCallViaDeskPhoneResponses, PostSoftphoneGenerateConnectionTokenData, PostSoftphoneGenerateConnectionTokenResponses, PostSoftphoneGenerateExtensionTokenData, PostSoftphoneGenerateExtensionTokenResponses, PostSoftphoneGenerateListenTokenData, PostSoftphoneGenerateListenTokenResponses, PostSubscribedNumbersStoreData, PostSubscribedNumbersStoreResponses, PostTenantHardwareOrdersCancelData, PostTenantHardwareOrdersCancelResponses, PostTenantHardwareOrdersQuoteData, PostTenantHardwareOrdersQuoteResponses, PostTenantHardwareOrdersSubmitData, PostTenantHardwareOrdersSubmitPreSubmittedData, PostTenantHardwareOrdersSubmitPreSubmittedResponses, PostTenantHardwareOrdersSubmitResponses, PostTenantOverviewMarkReceivedData, PostTenantOverviewMarkReceivedResponses, PostTimeConditionsCreateConditionData, PostTimeConditionsCreateConditionResponses, PostTimeConditionsSetStatusData, PostTimeConditionsSetStatusResponses, PostTwilioSmsStatusHandleData, PostTwilioSmsStatusHandleResponses, PostUploadsUploadData, PostUploadsUploadFromUrlData, PostUploadsUploadFromUrlResponses, PostUploadsUploadResponses, PostZynoRpcDispatchData, PostZynoRpcDispatchResponses, PutAiAgentsUpdateAgentData, PutAiAgentsUpdateAgentResponses, PutAiAgentsUpdateTestDraftData, PutAiAgentsUpdateTestDraftResponses, PutAllowlistUpdateEntryData, PutAllowlistUpdateEntryResponses, PutByocAccountsUpdateData, PutByocAccountsUpdateResponses, PutByocNumberConfigsUpdateAccountData, PutByocNumberConfigsUpdateAccountResponses, PutByocNumberConfigsUpdateData, PutByocNumberConfigsUpdateResponses, PutCallerRoutesUpdateData, PutCallerRoutesUpdateResponses, PutCallFlowConfigsUpdateConfigData, PutCallFlowConfigsUpdateConfigResponses, PutCarrierTelnyxEmergencyAddressesUpdateData, PutCarrierTelnyxEmergencyAddressesUpdateResponses, PutCatalogAdminUpsertItemData, PutCatalogAdminUpsertItemResponses, PutCatalogAdminUpsertPriceData, PutCatalogAdminUpsertPriceResponses, PutCatalogAdminUpsertRelationData, PutCatalogAdminUpsertRelationResponses, PutCatalogAdminUpsertVendorSkuData, PutCatalogAdminUpsertVendorSkuResponses, PutEndpointConfigsUpdateConfigurationData, PutEndpointConfigsUpdateConfigurationResponses, PutEndpointRemoteLoggingSetRemoteLoggingData, PutEndpointRemoteLoggingSetRemoteLoggingResponses, PutEndpointsUpdateAdditionalExtensionData, PutEndpointsUpdateAdditionalExtensionResponses, PutEndpointsUpdateEndpointData, PutEndpointsUpdateEndpointResponses, PutExtensionsUpdateExtensionData, PutExtensionsUpdateExtensionResponses, PutGreetingsUpdateGreetingData, PutGreetingsUpdateGreetingResponses, PutHoldMusicUpdateHoldMusicData, PutHoldMusicUpdateHoldMusicResponses, PutNumbersUpdateData, PutNumbersUpdateResponses, PutOutboundRoutesUpdateRouteData, PutOutboundRoutesUpdateRouteResponses, PutParkingLotsUpdateLotData, PutParkingLotsUpdateLotResponses, PutRingGroupsUpdateAssignmentScheduleData, PutRingGroupsUpdateAssignmentScheduleResponses, PutRingGroupsUpdateGroupData, PutRingGroupsUpdateGroupResponses, PutSaByocNumbersUpdateConfigData, PutSaByocNumbersUpdateConfigResponses, PutSaByocNumbersUpdateData, PutSaByocNumbersUpdateResponses, PutSaTalkTenantsUpdateTenantData, PutSaTalkTenantsUpdateTenantResponses, PutSaTenantByocAccountsUpdateData, PutSaTenantByocAccountsUpdateResponses, PutSmsBrandsUpdateData, PutSmsBrandsUpdateResponses, PutSmsRegistrationsAdminUpdateCampaignMessagingData, PutSmsRegistrationsAdminUpdateCampaignMessagingResponses, PutSmsTelnyxRegistrationsAdminBindBrandData, PutSmsTelnyxRegistrationsAdminBindBrandResponses, PutSmsTelnyxRegistrationsAdminBindCampaignData, PutSmsTelnyxRegistrationsAdminBindCampaignResponses, PutSmsTelnyxRegistrationsAdminSetBrandRegistrationData, PutSmsTelnyxRegistrationsAdminSetBrandRegistrationResponses, PutSmsTelnyxRegistrationsAdminUpdateCampaignData, PutSmsTelnyxRegistrationsAdminUpdateCampaignRegistrationTemplateData, PutSmsTelnyxRegistrationsAdminUpdateCampaignRegistrationTemplateResponses, PutSmsTelnyxRegistrationsAdminUpdateCampaignResponses, PutTenantUpdateTenantData, PutTenantUpdateTenantResponses, PutTimeConditionsUpdateConditionData, PutTimeConditionsUpdateConditionResponses, PutVoicemailUpdateFlagData, PutVoicemailUpdateFlagResponses, PutWorkstationExtensionLinksSetData, PutWorkstationExtensionLinksSetResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class TalkAdminApi {
    public static postAdminSetConfig<ThrowOnError extends boolean = false>(options: Options<PostAdminSetConfigData, ThrowOnError>): RequestResult<PostAdminSetConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAdminSetConfigResponses, unknown, ThrowOnError>({
            url: '/sa/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkSaTalkRuntimeApi {
    /**
     * Cross-tenant live-call snapshot from the Nexus-owned runtime store (not a CDR table scan). Sysadmins see full detail with no masking, including calls whose durable CDR row is `redacted`.
     */
    public static getSaTalkRuntimeLiveCalls<ThrowOnError extends boolean = false>(options?: Options<GetSaTalkRuntimeLiveCallsData, ThrowOnError>): RequestResult<GetSaTalkRuntimeLiveCallsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSaTalkRuntimeLiveCallsResponses, unknown, ThrowOnError>({ url: '/sa/live-calls', ...options });
    }
    
    /**
     * Delta poll against the cursor from `GET /sa/live-calls` (or a previous call to this route).
     */
    public static getSaTalkRuntimeLiveCallsChanges<ThrowOnError extends boolean = false>(options?: Options<GetSaTalkRuntimeLiveCallsChangesData, ThrowOnError>): RequestResult<GetSaTalkRuntimeLiveCallsChangesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSaTalkRuntimeLiveCallsChangesResponses, unknown, ThrowOnError>({ url: '/sa/live-calls/changes', ...options });
    }
    
    /**
     * Lists unexpired native SIP contacts, one row per registered account, oldest registration first. Can be polled as a complete snapshot. Includes unassigned bootstrap contacts and preserves unknown references; excludes registrations for soft-deleted endpoints. Read failures propagate.
     */
    public static getSaTalkRuntimeListRegistrations<ThrowOnError extends boolean = false>(options?: Options<GetSaTalkRuntimeListRegistrationsData, ThrowOnError>): RequestResult<GetSaTalkRuntimeListRegistrationsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSaTalkRuntimeListRegistrationsResponses, unknown, ThrowOnError>({ url: '/sa/registrations', ...options });
    }
}

export class TalkSaTalkTenantsApi {
    public static getSaTalkTenantsList<ThrowOnError extends boolean = false>(options?: Options<GetSaTalkTenantsListData, ThrowOnError>): RequestResult<GetSaTalkTenantsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSaTalkTenantsListResponses, unknown, ThrowOnError>({ url: '/sa/tenants', ...options });
    }
    
    public static getSaTalkTenantsGet<ThrowOnError extends boolean = false>(options: Options<GetSaTalkTenantsGetData, ThrowOnError>): RequestResult<GetSaTalkTenantsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaTalkTenantsGetResponses, unknown, ThrowOnError>({ url: '/sa/tenants/{id}', ...options });
    }
    
    public static putSaTalkTenantsUpdateTenant<ThrowOnError extends boolean = false>(options: Options<PutSaTalkTenantsUpdateTenantData, ThrowOnError>): RequestResult<PutSaTalkTenantsUpdateTenantResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSaTalkTenantsUpdateTenantResponses, unknown, ThrowOnError>({
            url: '/sa/tenants/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkTalkAuditApi {
    public static getTalkAuditIndex<ThrowOnError extends boolean = false>(options?: Options<GetTalkAuditIndexData, ThrowOnError>): RequestResult<GetTalkAuditIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTalkAuditIndexResponses, unknown, ThrowOnError>({ url: '/audit', ...options });
    }
}

export class TalkTenantApi {
    public static getTenantGetTenant<ThrowOnError extends boolean = false>(options?: Options<GetTenantGetTenantData, ThrowOnError>): RequestResult<GetTenantGetTenantResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantGetTenantResponses, unknown, ThrowOnError>({ url: '/tenant', ...options });
    }
    
    public static putTenantUpdateTenant<ThrowOnError extends boolean = false>(options: Options<PutTenantUpdateTenantData, ThrowOnError>): RequestResult<PutTenantUpdateTenantResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutTenantUpdateTenantResponses, unknown, ThrowOnError>({
            url: '/tenant',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkZynoRpcApi {
    public static postZynoRpcDispatch<ThrowOnError extends boolean = false>(options: Options<PostZynoRpcDispatchData, ThrowOnError>): RequestResult<PostZynoRpcDispatchResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostZynoRpcDispatchResponses, unknown, ThrowOnError>({ url: '/zrpc/{svc}/{method}', ...options });
    }
}

export class TalkByocAccountsApi {
    public static getByocAccountsList<ThrowOnError extends boolean = false>(options?: Options<GetByocAccountsListData, ThrowOnError>): RequestResult<GetByocAccountsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetByocAccountsListResponses, unknown, ThrowOnError>({ url: '/byoc/accounts', ...options });
    }
    
    public static postByocAccountsCreate<ThrowOnError extends boolean = false>(options: Options<PostByocAccountsCreateData, ThrowOnError>): RequestResult<PostByocAccountsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostByocAccountsCreateResponses, unknown, ThrowOnError>({
            url: '/byoc/accounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteByocAccountsRemove<ThrowOnError extends boolean = false>(options: Options<DeleteByocAccountsRemoveData, ThrowOnError>): RequestResult<DeleteByocAccountsRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteByocAccountsRemoveResponses, unknown, ThrowOnError>({ url: '/byoc/accounts/{id}', ...options });
    }
    
    public static getByocAccountsGet<ThrowOnError extends boolean = false>(options: Options<GetByocAccountsGetData, ThrowOnError>): RequestResult<GetByocAccountsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetByocAccountsGetResponses, unknown, ThrowOnError>({ url: '/byoc/accounts/{id}', ...options });
    }
    
    public static putByocAccountsUpdate<ThrowOnError extends boolean = false>(options: Options<PutByocAccountsUpdateData, ThrowOnError>): RequestResult<PutByocAccountsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutByocAccountsUpdateResponses, unknown, ThrowOnError>({
            url: '/byoc/accounts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Live list of the DIDs the carrier owns, annotated with whether each is already added for this tenant.
     */
    public static getByocAccountsAvailableNumbers<ThrowOnError extends boolean = false>(options: Options<GetByocAccountsAvailableNumbersData, ThrowOnError>): RequestResult<GetByocAccountsAvailableNumbersResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetByocAccountsAvailableNumbersResponses, unknown, ThrowOnError>({ url: '/byoc/accounts/{id}/available-numbers', ...options });
    }
    
    /**
     * Create one or more numbers under the carrier (bulk click-to-add). Record-only; no Telnyx sync.
     */
    public static postByocAccountsCreateNumbers<ThrowOnError extends boolean = false>(options: Options<PostByocAccountsCreateNumbersData, ThrowOnError>): RequestResult<PostByocAccountsCreateNumbersResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostByocAccountsCreateNumbersResponses, unknown, ThrowOnError>({
            url: '/byoc/accounts/{id}/numbers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkByocNumberConfigsApi {
    /**
     * Move an existing BYOC DID to another active carrier account owned by the caller's tenant.
     */
    public static putByocNumberConfigsUpdateAccount<ThrowOnError extends boolean = false>(options: Options<PutByocNumberConfigsUpdateAccountData, ThrowOnError>): RequestResult<PutByocNumberConfigsUpdateAccountResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutByocNumberConfigsUpdateAccountResponses, unknown, ThrowOnError>({
            url: '/byoc/numbers/{numberId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getByocNumberConfigsGet<ThrowOnError extends boolean = false>(options: Options<GetByocNumberConfigsGetData, ThrowOnError>): RequestResult<GetByocNumberConfigsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetByocNumberConfigsGetResponses, unknown, ThrowOnError>({ url: '/byoc/numbers/{numberId}/config', ...options });
    }
    
    public static putByocNumberConfigsUpdate<ThrowOnError extends boolean = false>(options: Options<PutByocNumberConfigsUpdateData, ThrowOnError>): RequestResult<PutByocNumberConfigsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutByocNumberConfigsUpdateResponses, unknown, ThrowOnError>({
            url: '/byoc/numbers/{numberId}/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkSaTenantByocAccountsApi {
    public static getSaTenantByocAccountsList<ThrowOnError extends boolean = false>(options: Options<GetSaTenantByocAccountsListData, ThrowOnError>): RequestResult<GetSaTenantByocAccountsListResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaTenantByocAccountsListResponses, unknown, ThrowOnError>({ url: '/sa/tenants/{tenantId}/byoc/accounts', ...options });
    }
    
    public static postSaTenantByocAccountsCreate<ThrowOnError extends boolean = false>(options: Options<PostSaTenantByocAccountsCreateData, ThrowOnError>): RequestResult<PostSaTenantByocAccountsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSaTenantByocAccountsCreateResponses, unknown, ThrowOnError>({
            url: '/sa/tenants/{tenantId}/byoc/accounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteSaTenantByocAccountsRemove<ThrowOnError extends boolean = false>(options: Options<DeleteSaTenantByocAccountsRemoveData, ThrowOnError>): RequestResult<DeleteSaTenantByocAccountsRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteSaTenantByocAccountsRemoveResponses, unknown, ThrowOnError>({ url: '/sa/tenants/{tenantId}/byoc/accounts/{id}', ...options });
    }
    
    public static getSaTenantByocAccountsGet<ThrowOnError extends boolean = false>(options: Options<GetSaTenantByocAccountsGetData, ThrowOnError>): RequestResult<GetSaTenantByocAccountsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaTenantByocAccountsGetResponses, unknown, ThrowOnError>({ url: '/sa/tenants/{tenantId}/byoc/accounts/{id}', ...options });
    }
    
    public static putSaTenantByocAccountsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSaTenantByocAccountsUpdateData, ThrowOnError>): RequestResult<PutSaTenantByocAccountsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSaTenantByocAccountsUpdateResponses, unknown, ThrowOnError>({
            url: '/sa/tenants/{tenantId}/byoc/accounts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkSaByocNumbersApi {
    public static getSaByocNumbersList<ThrowOnError extends boolean = false>(options: Options<GetSaByocNumbersListData, ThrowOnError>): RequestResult<GetSaByocNumbersListResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaByocNumbersListResponses, unknown, ThrowOnError>({ url: '/sa/byoc/tenants/{tenantId}/numbers', ...options });
    }
    
    public static postSaByocNumbersCreate<ThrowOnError extends boolean = false>(options: Options<PostSaByocNumbersCreateData, ThrowOnError>): RequestResult<PostSaByocNumbersCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSaByocNumbersCreateResponses, unknown, ThrowOnError>({
            url: '/sa/byoc/tenants/{tenantId}/numbers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteSaByocNumbersRemove<ThrowOnError extends boolean = false>(options: Options<DeleteSaByocNumbersRemoveData, ThrowOnError>): RequestResult<DeleteSaByocNumbersRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteSaByocNumbersRemoveResponses, unknown, ThrowOnError>({ url: '/sa/byoc/tenants/{tenantId}/numbers/{numberId}', ...options });
    }
    
    /**
     * Move an existing BYOC DID to another active carrier account owned by this tenant.
     */
    public static putSaByocNumbersUpdate<ThrowOnError extends boolean = false>(options: Options<PutSaByocNumbersUpdateData, ThrowOnError>): RequestResult<PutSaByocNumbersUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSaByocNumbersUpdateResponses, unknown, ThrowOnError>({
            url: '/sa/byoc/tenants/{tenantId}/numbers/{numberId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getSaByocNumbersGetConfig<ThrowOnError extends boolean = false>(options: Options<GetSaByocNumbersGetConfigData, ThrowOnError>): RequestResult<GetSaByocNumbersGetConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaByocNumbersGetConfigResponses, unknown, ThrowOnError>({ url: '/sa/byoc/tenants/{tenantId}/numbers/{numberId}/config', ...options });
    }
    
    public static putSaByocNumbersUpdateConfig<ThrowOnError extends boolean = false>(options: Options<PutSaByocNumbersUpdateConfigData, ThrowOnError>): RequestResult<PutSaByocNumbersUpdateConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSaByocNumbersUpdateConfigResponses, unknown, ThrowOnError>({
            url: '/sa/byoc/tenants/{tenantId}/numbers/{numberId}/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkAiAgentsApi {
    public static postAiAgentsCreateTestSession<ThrowOnError extends boolean = false>(options: Options<PostAiAgentsCreateTestSessionData, ThrowOnError>): RequestResult<PostAiAgentsCreateTestSessionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAiAgentsCreateTestSessionResponses, unknown, ThrowOnError>({
            url: '/call-flow/ai-agents/test-sessions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putAiAgentsUpdateTestDraft<ThrowOnError extends boolean = false>(options: Options<PutAiAgentsUpdateTestDraftData, ThrowOnError>): RequestResult<PutAiAgentsUpdateTestDraftResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutAiAgentsUpdateTestDraftResponses, unknown, ThrowOnError>({
            url: '/call-flow/ai-agents/test-sessions/{testId}/draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postAiAgentsHeartbeatTestSession<ThrowOnError extends boolean = false>(options: Options<PostAiAgentsHeartbeatTestSessionData, ThrowOnError>): RequestResult<PostAiAgentsHeartbeatTestSessionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAiAgentsHeartbeatTestSessionResponses, unknown, ThrowOnError>({ url: '/call-flow/ai-agents/test-sessions/{testId}/heartbeat', ...options });
    }
    
    public static deleteAiAgentsDeleteTestSession<ThrowOnError extends boolean = false>(options: Options<DeleteAiAgentsDeleteTestSessionData, ThrowOnError>): RequestResult<DeleteAiAgentsDeleteTestSessionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteAiAgentsDeleteTestSessionResponses, unknown, ThrowOnError>({ url: '/call-flow/ai-agents/test-sessions/{testId}', ...options });
    }
    
    public static getAiAgentsGetTestSession<ThrowOnError extends boolean = false>(options: Options<GetAiAgentsGetTestSessionData, ThrowOnError>): RequestResult<GetAiAgentsGetTestSessionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetAiAgentsGetTestSessionResponses, unknown, ThrowOnError>({ url: '/call-flow/ai-agents/test-sessions/{testId}', ...options });
    }
    
    public static postAiAgentsOptimizePrompt<ThrowOnError extends boolean = false>(options: Options<PostAiAgentsOptimizePromptData, ThrowOnError>): RequestResult<PostAiAgentsOptimizePromptResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAiAgentsOptimizePromptResponses, unknown, ThrowOnError>({
            url: '/call-flow/ai-agents/optimize-prompt',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getAiAgentsGetCapabilities<ThrowOnError extends boolean = false>(options?: Options<GetAiAgentsGetCapabilitiesData, ThrowOnError>): RequestResult<GetAiAgentsGetCapabilitiesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAiAgentsGetCapabilitiesResponses, unknown, ThrowOnError>({ url: '/call-flow/ai-agents/capabilities', ...options });
    }
    
    public static getAiAgentsListAgents<ThrowOnError extends boolean = false>(options?: Options<GetAiAgentsListAgentsData, ThrowOnError>): RequestResult<GetAiAgentsListAgentsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAiAgentsListAgentsResponses, unknown, ThrowOnError>({ url: '/call-flow/ai-agents', ...options });
    }
    
    public static postAiAgentsCreateAgent<ThrowOnError extends boolean = false>(options: Options<PostAiAgentsCreateAgentData, ThrowOnError>): RequestResult<PostAiAgentsCreateAgentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAiAgentsCreateAgentResponses, unknown, ThrowOnError>({
            url: '/call-flow/ai-agents',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteAiAgentsDeleteAgent<ThrowOnError extends boolean = false>(options: Options<DeleteAiAgentsDeleteAgentData, ThrowOnError>): RequestResult<DeleteAiAgentsDeleteAgentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteAiAgentsDeleteAgentResponses, unknown, ThrowOnError>({ url: '/call-flow/ai-agents/{id}', ...options });
    }
    
    public static getAiAgentsGetAgent<ThrowOnError extends boolean = false>(options: Options<GetAiAgentsGetAgentData, ThrowOnError>): RequestResult<GetAiAgentsGetAgentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetAiAgentsGetAgentResponses, unknown, ThrowOnError>({ url: '/call-flow/ai-agents/{id}', ...options });
    }
    
    public static putAiAgentsUpdateAgent<ThrowOnError extends boolean = false>(options: Options<PutAiAgentsUpdateAgentData, ThrowOnError>): RequestResult<PutAiAgentsUpdateAgentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutAiAgentsUpdateAgentResponses, unknown, ThrowOnError>({
            url: '/call-flow/ai-agents/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkCallFlowConfigsApi {
    public static getCallFlowConfigsListConfigs<ThrowOnError extends boolean = false>(options?: Options<GetCallFlowConfigsListConfigsData, ThrowOnError>): RequestResult<GetCallFlowConfigsListConfigsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCallFlowConfigsListConfigsResponses, unknown, ThrowOnError>({ url: '/call-flow/configs', ...options });
    }
    
    public static postCallFlowConfigsCreateConfig<ThrowOnError extends boolean = false>(options: Options<PostCallFlowConfigsCreateConfigData, ThrowOnError>): RequestResult<PostCallFlowConfigsCreateConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCallFlowConfigsCreateConfigResponses, unknown, ThrowOnError>({
            url: '/call-flow/configs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCallFlowConfigsDeleteConfig<ThrowOnError extends boolean = false>(options: Options<DeleteCallFlowConfigsDeleteConfigData, ThrowOnError>): RequestResult<DeleteCallFlowConfigsDeleteConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCallFlowConfigsDeleteConfigResponses, unknown, ThrowOnError>({ url: '/call-flow/configs/{id}', ...options });
    }
    
    public static getCallFlowConfigsGetConfig<ThrowOnError extends boolean = false>(options: Options<GetCallFlowConfigsGetConfigData, ThrowOnError>): RequestResult<GetCallFlowConfigsGetConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCallFlowConfigsGetConfigResponses, unknown, ThrowOnError>({ url: '/call-flow/configs/{id}', ...options });
    }
    
    public static putCallFlowConfigsUpdateConfig<ThrowOnError extends boolean = false>(options: Options<PutCallFlowConfigsUpdateConfigData, ThrowOnError>): RequestResult<PutCallFlowConfigsUpdateConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCallFlowConfigsUpdateConfigResponses, unknown, ThrowOnError>({
            url: '/call-flow/configs/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getCallFlowConfigsListHistory<ThrowOnError extends boolean = false>(options: Options<GetCallFlowConfigsListHistoryData, ThrowOnError>): RequestResult<GetCallFlowConfigsListHistoryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCallFlowConfigsListHistoryResponses, unknown, ThrowOnError>({ url: '/call-flow/configs/{id}/history', ...options });
    }
    
    public static postCallFlowConfigsRestoreHistory<ThrowOnError extends boolean = false>(options: Options<PostCallFlowConfigsRestoreHistoryData, ThrowOnError>): RequestResult<PostCallFlowConfigsRestoreHistoryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCallFlowConfigsRestoreHistoryResponses, unknown, ThrowOnError>({ url: '/call-flow/configs/{id}/restore/{historyId}', ...options });
    }
}

export class TalkCallerRoutesApi {
    public static getCallerRoutesList<ThrowOnError extends boolean = false>(options?: Options<GetCallerRoutesListData, ThrowOnError>): RequestResult<GetCallerRoutesListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCallerRoutesListResponses, unknown, ThrowOnError>({ url: '/call-flow/caller-routes', ...options });
    }
    
    public static postCallerRoutesCreate<ThrowOnError extends boolean = false>(options: Options<PostCallerRoutesCreateData, ThrowOnError>): RequestResult<PostCallerRoutesCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCallerRoutesCreateResponses, unknown, ThrowOnError>({
            url: '/call-flow/caller-routes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCallerRoutesRemove<ThrowOnError extends boolean = false>(options: Options<DeleteCallerRoutesRemoveData, ThrowOnError>): RequestResult<DeleteCallerRoutesRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCallerRoutesRemoveResponses, unknown, ThrowOnError>({ url: '/call-flow/caller-routes/{id}', ...options });
    }
    
    public static getCallerRoutesGet<ThrowOnError extends boolean = false>(options: Options<GetCallerRoutesGetData, ThrowOnError>): RequestResult<GetCallerRoutesGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCallerRoutesGetResponses, unknown, ThrowOnError>({ url: '/call-flow/caller-routes/{id}', ...options });
    }
    
    public static putCallerRoutesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCallerRoutesUpdateData, ThrowOnError>): RequestResult<PutCallerRoutesUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCallerRoutesUpdateResponses, unknown, ThrowOnError>({
            url: '/call-flow/caller-routes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkOutboundRoutesApi {
    public static getOutboundRoutesListRoutes<ThrowOnError extends boolean = false>(options?: Options<GetOutboundRoutesListRoutesData, ThrowOnError>): RequestResult<GetOutboundRoutesListRoutesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetOutboundRoutesListRoutesResponses, unknown, ThrowOnError>({ url: '/call-flow/outbound-routes', ...options });
    }
    
    public static postOutboundRoutesCreateRoute<ThrowOnError extends boolean = false>(options: Options<PostOutboundRoutesCreateRouteData, ThrowOnError>): RequestResult<PostOutboundRoutesCreateRouteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOutboundRoutesCreateRouteResponses, unknown, ThrowOnError>({
            url: '/call-flow/outbound-routes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteOutboundRoutesDeleteRoute<ThrowOnError extends boolean = false>(options: Options<DeleteOutboundRoutesDeleteRouteData, ThrowOnError>): RequestResult<DeleteOutboundRoutesDeleteRouteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteOutboundRoutesDeleteRouteResponses, unknown, ThrowOnError>({ url: '/call-flow/outbound-routes/{id}', ...options });
    }
    
    public static getOutboundRoutesGetRoute<ThrowOnError extends boolean = false>(options: Options<GetOutboundRoutesGetRouteData, ThrowOnError>): RequestResult<GetOutboundRoutesGetRouteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetOutboundRoutesGetRouteResponses, unknown, ThrowOnError>({ url: '/call-flow/outbound-routes/{id}', ...options });
    }
    
    public static putOutboundRoutesUpdateRoute<ThrowOnError extends boolean = false>(options: Options<PutOutboundRoutesUpdateRouteData, ThrowOnError>): RequestResult<PutOutboundRoutesUpdateRouteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutOutboundRoutesUpdateRouteResponses, unknown, ThrowOnError>({
            url: '/call-flow/outbound-routes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkParkingLotsApi {
    public static getParkingLotsListLots<ThrowOnError extends boolean = false>(options?: Options<GetParkingLotsListLotsData, ThrowOnError>): RequestResult<GetParkingLotsListLotsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetParkingLotsListLotsResponses, unknown, ThrowOnError>({ url: '/call-flow/parking-lots', ...options });
    }
    
    public static postParkingLotsCreateLot<ThrowOnError extends boolean = false>(options: Options<PostParkingLotsCreateLotData, ThrowOnError>): RequestResult<PostParkingLotsCreateLotResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostParkingLotsCreateLotResponses, unknown, ThrowOnError>({
            url: '/call-flow/parking-lots',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteParkingLotsDeleteLot<ThrowOnError extends boolean = false>(options: Options<DeleteParkingLotsDeleteLotData, ThrowOnError>): RequestResult<DeleteParkingLotsDeleteLotResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteParkingLotsDeleteLotResponses, unknown, ThrowOnError>({ url: '/call-flow/parking-lots/{id}', ...options });
    }
    
    public static getParkingLotsGetLot<ThrowOnError extends boolean = false>(options: Options<GetParkingLotsGetLotData, ThrowOnError>): RequestResult<GetParkingLotsGetLotResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetParkingLotsGetLotResponses, unknown, ThrowOnError>({ url: '/call-flow/parking-lots/{id}', ...options });
    }
    
    public static putParkingLotsUpdateLot<ThrowOnError extends boolean = false>(options: Options<PutParkingLotsUpdateLotData, ThrowOnError>): RequestResult<PutParkingLotsUpdateLotResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutParkingLotsUpdateLotResponses, unknown, ThrowOnError>({
            url: '/call-flow/parking-lots/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getParkingLotsGetLotCalls<ThrowOnError extends boolean = false>(options: Options<GetParkingLotsGetLotCallsData, ThrowOnError>): RequestResult<GetParkingLotsGetLotCallsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetParkingLotsGetLotCallsResponses, unknown, ThrowOnError>({ url: '/call-flow/parking-lots/{id}/calls', ...options });
    }
}

export class TalkRingGroupsApi {
    public static getRingGroupsListGroups<ThrowOnError extends boolean = false>(options?: Options<GetRingGroupsListGroupsData, ThrowOnError>): RequestResult<GetRingGroupsListGroupsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetRingGroupsListGroupsResponses, unknown, ThrowOnError>({ url: '/call-flow/ring-groups', ...options });
    }
    
    public static postRingGroupsCreateGroup<ThrowOnError extends boolean = false>(options: Options<PostRingGroupsCreateGroupData, ThrowOnError>): RequestResult<PostRingGroupsCreateGroupResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostRingGroupsCreateGroupResponses, unknown, ThrowOnError>({
            url: '/call-flow/ring-groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteRingGroupsDeleteGroup<ThrowOnError extends boolean = false>(options: Options<DeleteRingGroupsDeleteGroupData, ThrowOnError>): RequestResult<DeleteRingGroupsDeleteGroupResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteRingGroupsDeleteGroupResponses, unknown, ThrowOnError>({ url: '/call-flow/ring-groups/{id}', ...options });
    }
    
    public static getRingGroupsGetGroup<ThrowOnError extends boolean = false>(options: Options<GetRingGroupsGetGroupData, ThrowOnError>): RequestResult<GetRingGroupsGetGroupResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetRingGroupsGetGroupResponses, unknown, ThrowOnError>({ url: '/call-flow/ring-groups/{id}', ...options });
    }
    
    public static putRingGroupsUpdateGroup<ThrowOnError extends boolean = false>(options: Options<PutRingGroupsUpdateGroupData, ThrowOnError>): RequestResult<PutRingGroupsUpdateGroupResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutRingGroupsUpdateGroupResponses, unknown, ThrowOnError>({
            url: '/call-flow/ring-groups/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putRingGroupsUpdateAssignmentSchedule<ThrowOnError extends boolean = false>(options: Options<PutRingGroupsUpdateAssignmentScheduleData, ThrowOnError>): RequestResult<PutRingGroupsUpdateAssignmentScheduleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutRingGroupsUpdateAssignmentScheduleResponses, unknown, ThrowOnError>({
            url: '/call-flow/ring-groups/{id}/assignment-schedule',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getRingGroupsGetEffectiveMembers<ThrowOnError extends boolean = false>(options: Options<GetRingGroupsGetEffectiveMembersData, ThrowOnError>): RequestResult<GetRingGroupsGetEffectiveMembersResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetRingGroupsGetEffectiveMembersResponses, unknown, ThrowOnError>({ url: '/call-flow/ring-groups/{id}/effective-members', ...options });
    }
}

export class TalkTimeConditionsApi {
    public static getTimeConditionsListConditions<ThrowOnError extends boolean = false>(options?: Options<GetTimeConditionsListConditionsData, ThrowOnError>): RequestResult<GetTimeConditionsListConditionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTimeConditionsListConditionsResponses, unknown, ThrowOnError>({ url: '/call-flow/time-conditions', ...options });
    }
    
    public static postTimeConditionsCreateCondition<ThrowOnError extends boolean = false>(options: Options<PostTimeConditionsCreateConditionData, ThrowOnError>): RequestResult<PostTimeConditionsCreateConditionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTimeConditionsCreateConditionResponses, unknown, ThrowOnError>({
            url: '/call-flow/time-conditions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteTimeConditionsDeleteCondition<ThrowOnError extends boolean = false>(options: Options<DeleteTimeConditionsDeleteConditionData, ThrowOnError>): RequestResult<DeleteTimeConditionsDeleteConditionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTimeConditionsDeleteConditionResponses, unknown, ThrowOnError>({ url: '/call-flow/time-conditions/{id}', ...options });
    }
    
    public static getTimeConditionsGetCondition<ThrowOnError extends boolean = false>(options: Options<GetTimeConditionsGetConditionData, ThrowOnError>): RequestResult<GetTimeConditionsGetConditionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetTimeConditionsGetConditionResponses, unknown, ThrowOnError>({ url: '/call-flow/time-conditions/{id}', ...options });
    }
    
    public static putTimeConditionsUpdateCondition<ThrowOnError extends boolean = false>(options: Options<PutTimeConditionsUpdateConditionData, ThrowOnError>): RequestResult<PutTimeConditionsUpdateConditionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutTimeConditionsUpdateConditionResponses, unknown, ThrowOnError>({
            url: '/call-flow/time-conditions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteTimeConditionsClearOverride<ThrowOnError extends boolean = false>(options: Options<DeleteTimeConditionsClearOverrideData, ThrowOnError>): RequestResult<DeleteTimeConditionsClearOverrideResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTimeConditionsClearOverrideResponses, unknown, ThrowOnError>({ url: '/call-flow/time-conditions/{id}/status', ...options });
    }
    
    public static getTimeConditionsGetStatus<ThrowOnError extends boolean = false>(options: Options<GetTimeConditionsGetStatusData, ThrowOnError>): RequestResult<GetTimeConditionsGetStatusResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetTimeConditionsGetStatusResponses, unknown, ThrowOnError>({ url: '/call-flow/time-conditions/{id}/status', ...options });
    }
    
    public static postTimeConditionsSetStatus<ThrowOnError extends boolean = false>(options: Options<PostTimeConditionsSetStatusData, ThrowOnError>): RequestResult<PostTimeConditionsSetStatusResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTimeConditionsSetStatusResponses, unknown, ThrowOnError>({
            url: '/call-flow/time-conditions/{id}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkCarrierTelnyxEventApi {
    public static postCarrierTelnyxEventHandleEvent<ThrowOnError extends boolean = false>(options: Options<PostCarrierTelnyxEventHandleEventData, ThrowOnError>): RequestResult<PostCarrierTelnyxEventHandleEventResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCarrierTelnyxEventHandleEventResponses, unknown, ThrowOnError>({
            url: '/public/carriers/telnyx/event',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkCarrierTelnyxEmergencyAddressesApi {
    public static getCarrierTelnyxEmergencyAddressesList<ThrowOnError extends boolean = false>(options?: Options<GetCarrierTelnyxEmergencyAddressesListData, ThrowOnError>): RequestResult<GetCarrierTelnyxEmergencyAddressesListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCarrierTelnyxEmergencyAddressesListResponses, unknown, ThrowOnError>({ url: '/carriers/telnyx/emergency-addresses', ...options });
    }
    
    public static putCarrierTelnyxEmergencyAddressesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCarrierTelnyxEmergencyAddressesUpdateData, ThrowOnError>): RequestResult<PutCarrierTelnyxEmergencyAddressesUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCarrierTelnyxEmergencyAddressesUpdateResponses, unknown, ThrowOnError>({
            url: '/carriers/telnyx/emergency-addresses/{locationId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkCarrierTelnyxNumbersApi {
    public static getCarrierTelnyxNumbersAvailableNumbers<ThrowOnError extends boolean = false>(options: Options<GetCarrierTelnyxNumbersAvailableNumbersData, ThrowOnError>): RequestResult<GetCarrierTelnyxNumbersAvailableNumbersResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCarrierTelnyxNumbersAvailableNumbersResponses, unknown, ThrowOnError>({ url: '/carriers/telnyx/available-numbers', ...options });
    }
    
    public static postCarrierTelnyxNumbersPortabilityChecks<ThrowOnError extends boolean = false>(options: Options<PostCarrierTelnyxNumbersPortabilityChecksData, ThrowOnError>): RequestResult<PostCarrierTelnyxNumbersPortabilityChecksResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCarrierTelnyxNumbersPortabilityChecksResponses, unknown, ThrowOnError>({
            url: '/carriers/telnyx/portability-checks',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCarrierTelnyxNumbersCreateNumberOrder<ThrowOnError extends boolean = false>(options: Options<PostCarrierTelnyxNumbersCreateNumberOrderData, ThrowOnError>): RequestResult<PostCarrierTelnyxNumbersCreateNumberOrderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCarrierTelnyxNumbersCreateNumberOrderResponses, unknown, ThrowOnError>({
            url: '/carriers/telnyx/number-orders',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCarrierTelnyxNumbersAttachExistingNumber<ThrowOnError extends boolean = false>(options: Options<PostCarrierTelnyxNumbersAttachExistingNumberData, ThrowOnError>): RequestResult<PostCarrierTelnyxNumbersAttachExistingNumberResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCarrierTelnyxNumbersAttachExistingNumberResponses, unknown, ThrowOnError>({
            url: '/carriers/telnyx/numbers/attach',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCarrierTelnyxNumbersCreatePortOrder<ThrowOnError extends boolean = false>(options: Options<PostCarrierTelnyxNumbersCreatePortOrderData, ThrowOnError>): RequestResult<PostCarrierTelnyxNumbersCreatePortOrderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCarrierTelnyxNumbersCreatePortOrderResponses, unknown, ThrowOnError>({
            url: '/carriers/telnyx/port-orders',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCarrierTelnyxNumbersDownloadPortOrderLoaTemplate<ThrowOnError extends boolean = false>(options: Options<PostCarrierTelnyxNumbersDownloadPortOrderLoaTemplateData, ThrowOnError>): RequestResult<PostCarrierTelnyxNumbersDownloadPortOrderLoaTemplateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCarrierTelnyxNumbersDownloadPortOrderLoaTemplateResponses, unknown, ThrowOnError>({
            url: '/carriers/telnyx/port-orders/loa-template',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkCarrierNumberBarnApi {
    public static getCarrierNumberBarnVanityNumbers<ThrowOnError extends boolean = false>(options: Options<GetCarrierNumberBarnVanityNumbersData, ThrowOnError>): RequestResult<GetCarrierNumberBarnVanityNumbersResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCarrierNumberBarnVanityNumbersResponses, unknown, ThrowOnError>({ url: '/carriers/numberbarn/vanity-numbers', ...options });
    }
    
    public static postCarrierNumberBarnCreateVanityOrder<ThrowOnError extends boolean = false>(options: Options<PostCarrierNumberBarnCreateVanityOrderData, ThrowOnError>): RequestResult<PostCarrierNumberBarnCreateVanityOrderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCarrierNumberBarnCreateVanityOrderResponses, unknown, ThrowOnError>({
            url: '/carriers/numberbarn/vanity-orders',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkCallControlApi {
    /**
     * Terminates this exact native call; related calls are controlled separately.
     */
    public static postCallControlKill<ThrowOnError extends boolean = false>(options: Options<PostCallControlKillData, ThrowOnError>): RequestResult<PostCallControlKillResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCallControlKillResponses, unknown, ThrowOnError>({ url: '/cdr/{callId}/kill', ...options });
    }
}

export class TalkCdrApi {
    public static getCdrGet<ThrowOnError extends boolean = false>(options?: Options<GetCdrGetData, ThrowOnError>): RequestResult<GetCdrGetResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCdrGetResponses, unknown, ThrowOnError>({ url: '/cdr', ...options });
    }
    
    /**
     * Cursor-paginated counterpart to the legacy array response.
     */
    public static getCdrGetPage<ThrowOnError extends boolean = false>(options?: Options<GetCdrGetPageData, ThrowOnError>): RequestResult<GetCdrGetPageResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCdrGetPageResponses, unknown, ThrowOnError>({ url: '/cdr/page', ...options });
    }
    
    /**
     * Per-extension live call state for the desk-phone/dock surfaces: the linked workstation extension and any starred/primary subscriptions. Registered before `GET :callId` so `live` is never captured as a callId.
     */
    public static getCdrLiveList<ThrowOnError extends boolean = false>(options: Options<GetCdrLiveListData, ThrowOnError>): RequestResult<GetCdrLiveListResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCdrLiveListResponses, unknown, ThrowOnError>({ url: '/cdr/live', ...options });
    }
    
    /**
     * Exact, non-paginated navigation for one customer conversation. The list endpoints intentionally remain root-only; this route also accepts an already-issued continuation UUID. A history parent is not an identity alias and never grants permission to read the parent.
     */
    public static getCdrDetail<ThrowOnError extends boolean = false>(options: Options<GetCdrDetailData, ThrowOnError>): RequestResult<GetCdrDetailResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCdrDetailResponses, unknown, ThrowOnError>({ url: '/cdr/{callId}', ...options });
    }
    
    /**
     * Content-free outcomes attached to one accessible root call. Resource IDs never grant access by themselves: voicemail and SMS IDs are withheld unless the caller has the respective source grant.
     */
    public static getCdrOutcomes<ThrowOnError extends boolean = false>(options: Options<GetCdrOutcomesData, ThrowOnError>): RequestResult<GetCdrOutcomesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCdrOutcomesResponses, unknown, ThrowOnError>({ url: '/cdr/{callId}/outcomes', ...options });
    }
    
    public static getCdrLive<ThrowOnError extends boolean = false>(options: Options<GetCdrLiveData, ThrowOnError>): RequestResult<GetCdrLiveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCdrLiveResponses, unknown, ThrowOnError>({ url: '/cdr/{callId}/live', ...options });
    }
    
    /**
     * Declines one extension's still-ringing devices on a live call. Never pickup — a ringing peer keeps ringing.
     */
    public static postCdrDecline<ThrowOnError extends boolean = false>(options: Options<PostCdrDeclineData, ThrowOnError>): RequestResult<PostCdrDeclineResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCdrDeclineResponses, unknown, ThrowOnError>({
            url: '/cdr/{callId}/decline',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkCdrIngestApi {
    public static postCdrIngestIngest<ThrowOnError extends boolean = false>(options: Options<PostCdrIngestIngestData, ThrowOnError>): RequestResult<PostCdrIngestIngestResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCdrIngestIngestResponses, unknown, ThrowOnError>({
            url: '/cdr',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkCallResearchApi {
    public static getCallResearchOverview<ThrowOnError extends boolean = false>(options: Options<GetCallResearchOverviewData, ThrowOnError>): RequestResult<GetCallResearchOverviewResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCallResearchOverviewResponses, unknown, ThrowOnError>({ url: '/cdr/{callId}/research', ...options });
    }
    
    /**
     * Terminal, CDR-backed quality evidence for this call only. Unlike Activity and SIP research this endpoint neither expands an interaction nor reads observability systems, so a transfer cannot disclose an independently authorized related call through an aggregate quality score.
     */
    public static getCallResearchQuality<ThrowOnError extends boolean = false>(options: Options<GetCallResearchQualityData, ThrowOnError>): RequestResult<GetCallResearchQualityResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCallResearchQualityResponses, unknown, ThrowOnError>({ url: '/cdr/{callId}/research/quality', ...options });
    }
    
    public static getCallResearchSip<ThrowOnError extends boolean = false>(options: Options<GetCallResearchSipData, ThrowOnError>): RequestResult<GetCallResearchSipResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCallResearchSipResponses, unknown, ThrowOnError>({ url: '/cdr/{callId}/research/sip', ...options });
    }
    
    public static getCallResearchDiagnostics<ThrowOnError extends boolean = false>(options: Options<GetCallResearchDiagnosticsData, ThrowOnError>): RequestResult<GetCallResearchDiagnosticsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCallResearchDiagnosticsResponses, unknown, ThrowOnError>({ url: '/cdr/{callId}/research/diagnostics', ...options });
    }
}

export class TalkCdrRecordingApi {
    /**
     * Deliberately the one recording route that serves an expired call: retention is a clock on the *audio*, and a transcript or summary generated while the audio lived outlives it. Expiry withholds the media URLs here and blocks the routes that hand out audio; it must not hide a transcript the customer still owns.
     */
    public static getCdrRecordingGetMeta<ThrowOnError extends boolean = false>(options: Options<GetCdrRecordingGetMetaData, ThrowOnError>): RequestResult<GetCdrRecordingGetMetaResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCdrRecordingGetMetaResponses, unknown, ThrowOnError>({ url: '/cdr/{id}/recording', ...options });
    }
    
    public static postCdrRecordingGenerateRecording<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingGenerateRecordingData, ThrowOnError>): RequestResult<PostCdrRecordingGenerateRecordingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCdrRecordingGenerateRecordingResponses, unknown, ThrowOnError>({ url: '/cdr/{id}/prepare-recording', ...options });
    }
    
    public static getCdrRecordingGetPreparedRecordingContent<ThrowOnError extends boolean = false>(options: Options<GetCdrRecordingGetPreparedRecordingContentData, ThrowOnError>): RequestResult<GetCdrRecordingGetPreparedRecordingContentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCdrRecordingGetPreparedRecordingContentResponses, unknown, ThrowOnError>({ url: '/cdr/{id}/prepared-recording', ...options });
    }
    
    public static postCdrRecordingGenerateTranscript<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingGenerateTranscriptData, ThrowOnError>): RequestResult<PostCdrRecordingGenerateTranscriptResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCdrRecordingGenerateTranscriptResponses, unknown, ThrowOnError>({ url: '/cdr/{id}/generate-transcript', ...options });
    }
    
    public static postCdrRecordingGenerateSummary<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingGenerateSummaryData, ThrowOnError>): RequestResult<PostCdrRecordingGenerateSummaryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCdrRecordingGenerateSummaryResponses, unknown, ThrowOnError>({ url: '/cdr/{id}/generate-summary', ...options });
    }
    
    public static postCdrRecordingGenerateAdHocSummary<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingGenerateAdHocSummaryData, ThrowOnError>): RequestResult<PostCdrRecordingGenerateAdHocSummaryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCdrRecordingGenerateAdHocSummaryResponses, unknown, ThrowOnError>({
            url: '/cdr/{id}/generate-adhoc-summary',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCdrRecordingRateSummary<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingRateSummaryData, ThrowOnError>): RequestResult<PostCdrRecordingRateSummaryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCdrRecordingRateSummaryResponses, unknown, ThrowOnError>({
            url: '/cdr/{id}/rate-summary',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCdrRecordingRateSentiment<ThrowOnError extends boolean = false>(options: Options<PostCdrRecordingRateSentimentData, ThrowOnError>): RequestResult<PostCdrRecordingRateSentimentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCdrRecordingRateSentimentResponses, unknown, ThrowOnError>({
            url: '/cdr/{id}/rate-sentiment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkCdrSummaryExperimentApi {
    public static postCdrSummaryExperimentGenerateAdHocSummaryFromTranscript<ThrowOnError extends boolean = false>(options: Options<PostCdrSummaryExperimentGenerateAdHocSummaryFromTranscriptData, ThrowOnError>): RequestResult<PostCdrSummaryExperimentGenerateAdHocSummaryFromTranscriptResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCdrSummaryExperimentGenerateAdHocSummaryFromTranscriptResponses, unknown, ThrowOnError>({
            url: '/cdr/generate-adhoc-summary',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkPresenceApi {
    public static getPresenceSnapshot<ThrowOnError extends boolean = false>(options?: Options<GetPresenceSnapshotData, ThrowOnError>): RequestResult<GetPresenceSnapshotResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetPresenceSnapshotResponses, unknown, ThrowOnError>({ url: '/presence', ...options });
    }
}

export class TalkEndpointRemoteLoggingApi {
    public static getEndpointRemoteLoggingGetRemoteLogging<ThrowOnError extends boolean = false>(options: Options<GetEndpointRemoteLoggingGetRemoteLoggingData, ThrowOnError>): RequestResult<GetEndpointRemoteLoggingGetRemoteLoggingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointRemoteLoggingGetRemoteLoggingResponses, unknown, ThrowOnError>({ url: '/endpoints/{id}/remote-logging', ...options });
    }
    
    public static putEndpointRemoteLoggingSetRemoteLogging<ThrowOnError extends boolean = false>(options: Options<PutEndpointRemoteLoggingSetRemoteLoggingData, ThrowOnError>): RequestResult<PutEndpointRemoteLoggingSetRemoteLoggingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutEndpointRemoteLoggingSetRemoteLoggingResponses, unknown, ThrowOnError>({
            url: '/endpoints/{id}/remote-logging',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getEndpointRemoteLoggingGetLogs<ThrowOnError extends boolean = false>(options: Options<GetEndpointRemoteLoggingGetLogsData, ThrowOnError>): RequestResult<GetEndpointRemoteLoggingGetLogsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointRemoteLoggingGetLogsResponses, unknown, ThrowOnError>({ url: '/endpoints/{id}/logs', ...options });
    }
}

export class TalkEndpointsApi {
    public static getEndpointsListEndpoints<ThrowOnError extends boolean = false>(options?: Options<GetEndpointsListEndpointsData, ThrowOnError>): RequestResult<GetEndpointsListEndpointsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetEndpointsListEndpointsResponses, unknown, ThrowOnError>({ url: '/endpoints', ...options });
    }
    
    public static postEndpointsCreateEndpoint<ThrowOnError extends boolean = false>(options: Options<PostEndpointsCreateEndpointData, ThrowOnError>): RequestResult<PostEndpointsCreateEndpointResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostEndpointsCreateEndpointResponses, unknown, ThrowOnError>({
            url: '/endpoints',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getEndpointsGetEndpoint<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetEndpointData, ThrowOnError>): RequestResult<GetEndpointsGetEndpointResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetEndpointResponses, unknown, ThrowOnError>({ url: '/endpoints/{id}', ...options });
    }
    
    public static putEndpointsUpdateEndpoint<ThrowOnError extends boolean = false>(options: Options<PutEndpointsUpdateEndpointData, ThrowOnError>): RequestResult<PutEndpointsUpdateEndpointResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutEndpointsUpdateEndpointResponses, unknown, ThrowOnError>({
            url: '/endpoints/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getEndpointsGetResolvedConfig<ThrowOnError extends boolean = false>(options: Options<GetEndpointsGetResolvedConfigData, ThrowOnError>): RequestResult<GetEndpointsGetResolvedConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointsGetResolvedConfigResponses, unknown, ThrowOnError>({ url: '/endpoints/{id}/resolved-config', ...options });
    }
    
    public static postEndpointsAttachAdditionalExtension<ThrowOnError extends boolean = false>(options: Options<PostEndpointsAttachAdditionalExtensionData, ThrowOnError>): RequestResult<PostEndpointsAttachAdditionalExtensionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostEndpointsAttachAdditionalExtensionResponses, unknown, ThrowOnError>({
            url: '/endpoints/{id}/additional-extensions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteEndpointsDetachAdditionalExtension<ThrowOnError extends boolean = false>(options: Options<DeleteEndpointsDetachAdditionalExtensionData, ThrowOnError>): RequestResult<DeleteEndpointsDetachAdditionalExtensionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteEndpointsDetachAdditionalExtensionResponses, unknown, ThrowOnError>({ url: '/endpoints/{endpointId}/additional-extensions/{id}', ...options });
    }
    
    public static putEndpointsUpdateAdditionalExtension<ThrowOnError extends boolean = false>(options: Options<PutEndpointsUpdateAdditionalExtensionData, ThrowOnError>): RequestResult<PutEndpointsUpdateAdditionalExtensionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutEndpointsUpdateAdditionalExtensionResponses, unknown, ThrowOnError>({
            url: '/endpoints/{endpointId}/additional-extensions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postEndpointsProvisionEndpoint<ThrowOnError extends boolean = false>(options: Options<PostEndpointsProvisionEndpointData, ThrowOnError>): RequestResult<PostEndpointsProvisionEndpointResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostEndpointsProvisionEndpointResponses, unknown, ThrowOnError>({ url: '/endpoints/{id}/provision', ...options });
    }
    
    public static postEndpointsRebootEndpoint<ThrowOnError extends boolean = false>(options: Options<PostEndpointsRebootEndpointData, ThrowOnError>): RequestResult<PostEndpointsRebootEndpointResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostEndpointsRebootEndpointResponses, unknown, ThrowOnError>({ url: '/endpoints/{id}/reboot', ...options });
    }
}

export class TalkEndpointConfigsApi {
    public static getEndpointConfigsListConfigurations<ThrowOnError extends boolean = false>(options?: Options<GetEndpointConfigsListConfigurationsData, ThrowOnError>): RequestResult<GetEndpointConfigsListConfigurationsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetEndpointConfigsListConfigurationsResponses, unknown, ThrowOnError>({ url: '/endpoint-configs', ...options });
    }
    
    public static postEndpointConfigsCreateConfiguration<ThrowOnError extends boolean = false>(options: Options<PostEndpointConfigsCreateConfigurationData, ThrowOnError>): RequestResult<PostEndpointConfigsCreateConfigurationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostEndpointConfigsCreateConfigurationResponses, unknown, ThrowOnError>({
            url: '/endpoint-configs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteEndpointConfigsDeleteConfiguration<ThrowOnError extends boolean = false>(options: Options<DeleteEndpointConfigsDeleteConfigurationData, ThrowOnError>): RequestResult<DeleteEndpointConfigsDeleteConfigurationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteEndpointConfigsDeleteConfigurationResponses, unknown, ThrowOnError>({ url: '/endpoint-configs/{id}', ...options });
    }
    
    public static getEndpointConfigsGetConfiguration<ThrowOnError extends boolean = false>(options: Options<GetEndpointConfigsGetConfigurationData, ThrowOnError>): RequestResult<GetEndpointConfigsGetConfigurationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetEndpointConfigsGetConfigurationResponses, unknown, ThrowOnError>({ url: '/endpoint-configs/{id}', ...options });
    }
    
    public static putEndpointConfigsUpdateConfiguration<ThrowOnError extends boolean = false>(options: Options<PutEndpointConfigsUpdateConfigurationData, ThrowOnError>): RequestResult<PutEndpointConfigsUpdateConfigurationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutEndpointConfigsUpdateConfigurationResponses, unknown, ThrowOnError>({
            url: '/endpoint-configs/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkGrandstreamEndpointsApi {
    public static postGrandstreamEndpointsGetRemoteWebUiUrl<ThrowOnError extends boolean = false>(options: Options<PostGrandstreamEndpointsGetRemoteWebUiUrlData, ThrowOnError>): RequestResult<PostGrandstreamEndpointsGetRemoteWebUiUrlResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostGrandstreamEndpointsGetRemoteWebUiUrlResponses, unknown, ThrowOnError>({ url: '/endpoints/{id}/grandstream/remote-web-ui', ...options });
    }
    
    public static postGrandstreamEndpointsGetScreenshot<ThrowOnError extends boolean = false>(options: Options<PostGrandstreamEndpointsGetScreenshotData, ThrowOnError>): RequestResult<PostGrandstreamEndpointsGetScreenshotResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostGrandstreamEndpointsGetScreenshotResponses, unknown, ThrowOnError>({ url: '/endpoints/{id}/grandstream/screenshot', ...options });
    }
}

export class TalkFaxesApi {
    public static getFaxesListFaxes<ThrowOnError extends boolean = false>(options?: Options<GetFaxesListFaxesData, ThrowOnError>): RequestResult<GetFaxesListFaxesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetFaxesListFaxesResponses, unknown, ThrowOnError>({ url: '/faxes', ...options });
    }
    
    public static postFaxesSendFax<ThrowOnError extends boolean = false>(options: Options<PostFaxesSendFaxData, ThrowOnError>): RequestResult<PostFaxesSendFaxResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFaxesSendFaxResponses, unknown, ThrowOnError>({
            ...formDataBodySerializer,
            url: '/faxes',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    public static getFaxesGetFax<ThrowOnError extends boolean = false>(options: Options<GetFaxesGetFaxData, ThrowOnError>): RequestResult<GetFaxesGetFaxResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetFaxesGetFaxResponses, unknown, ThrowOnError>({ url: '/faxes/{id}', ...options });
    }
    
    public static postFaxesRetryFax<ThrowOnError extends boolean = false>(options: Options<PostFaxesRetryFaxData, ThrowOnError>): RequestResult<PostFaxesRetryFaxResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFaxesRetryFaxResponses, unknown, ThrowOnError>({ url: '/faxes/{id}/retry', ...options });
    }
    
    public static postFaxesMarkFaxRead<ThrowOnError extends boolean = false>(options: Options<PostFaxesMarkFaxReadData, ThrowOnError>): RequestResult<PostFaxesMarkFaxReadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFaxesMarkFaxReadResponses, unknown, ThrowOnError>({ url: '/faxes/{id}/read', ...options });
    }
    
    public static postFaxesMarkFaxUnread<ThrowOnError extends boolean = false>(options: Options<PostFaxesMarkFaxUnreadData, ThrowOnError>): RequestResult<PostFaxesMarkFaxUnreadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFaxesMarkFaxUnreadResponses, unknown, ThrowOnError>({ url: '/faxes/{id}/unread', ...options });
    }
    
    public static postFaxesArchiveFax<ThrowOnError extends boolean = false>(options: Options<PostFaxesArchiveFaxData, ThrowOnError>): RequestResult<PostFaxesArchiveFaxResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFaxesArchiveFaxResponses, unknown, ThrowOnError>({ url: '/faxes/{id}/archive', ...options });
    }
    
    public static postFaxesUnarchiveFax<ThrowOnError extends boolean = false>(options: Options<PostFaxesUnarchiveFaxData, ThrowOnError>): RequestResult<PostFaxesUnarchiveFaxResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFaxesUnarchiveFaxResponses, unknown, ThrowOnError>({ url: '/faxes/{id}/unarchive', ...options });
    }
}

export class TalkFaxesWebhookApi {
    public static postFaxesWebhookHandlePayload<ThrowOnError extends boolean = false>(options: Options<PostFaxesWebhookHandlePayloadData, ThrowOnError>): RequestResult<PostFaxesWebhookHandlePayloadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFaxesWebhookHandlePayloadResponses, unknown, ThrowOnError>({
            url: '/public/faxes/webhook',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkAllowlistApi {
    public static getAllowlistListEntries<ThrowOnError extends boolean = false>(options?: Options<GetAllowlistListEntriesData, ThrowOnError>): RequestResult<GetAllowlistListEntriesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAllowlistListEntriesResponses, unknown, ThrowOnError>({ url: '/firewall/allowlist', ...options });
    }
    
    public static postAllowlistCreateEntry<ThrowOnError extends boolean = false>(options: Options<PostAllowlistCreateEntryData, ThrowOnError>): RequestResult<PostAllowlistCreateEntryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAllowlistCreateEntryResponses, unknown, ThrowOnError>({
            url: '/firewall/allowlist',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteAllowlistDeleteEntry<ThrowOnError extends boolean = false>(options: Options<DeleteAllowlistDeleteEntryData, ThrowOnError>): RequestResult<DeleteAllowlistDeleteEntryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteAllowlistDeleteEntryResponses, unknown, ThrowOnError>({ url: '/firewall/allowlist/{id}', ...options });
    }
    
    public static putAllowlistUpdateEntry<ThrowOnError extends boolean = false>(options: Options<PutAllowlistUpdateEntryData, ThrowOnError>): RequestResult<PutAllowlistUpdateEntryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutAllowlistUpdateEntryResponses, unknown, ThrowOnError>({
            url: '/firewall/allowlist/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkBlocklistApi {
    public static getBlocklistListBans<ThrowOnError extends boolean = false>(options?: Options<GetBlocklistListBansData, ThrowOnError>): RequestResult<GetBlocklistListBansResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetBlocklistListBansResponses, unknown, ThrowOnError>({ url: '/firewall/blocklist', ...options });
    }
    
    public static postBlocklistCreateBan<ThrowOnError extends boolean = false>(options: Options<PostBlocklistCreateBanData, ThrowOnError>): RequestResult<PostBlocklistCreateBanResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostBlocklistCreateBanResponses, unknown, ThrowOnError>({
            url: '/firewall/blocklist',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteBlocklistDeleteBan<ThrowOnError extends boolean = false>(options: Options<DeleteBlocklistDeleteBanData, ThrowOnError>): RequestResult<DeleteBlocklistDeleteBanResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteBlocklistDeleteBanResponses, unknown, ThrowOnError>({ url: '/firewall/blocklist/{target}/{prefix}', ...options });
    }
    
    public static getBlocklistGetBan<ThrowOnError extends boolean = false>(options: Options<GetBlocklistGetBanData, ThrowOnError>): RequestResult<GetBlocklistGetBanResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetBlocklistGetBanResponses, unknown, ThrowOnError>({ url: '/firewall/blocklist/{target}/{prefix}', ...options });
    }
    
    public static deleteBlocklistDeleteBan2<ThrowOnError extends boolean = false>(options: Options<DeleteBlocklistDeleteBan2Data, ThrowOnError>): RequestResult<DeleteBlocklistDeleteBan2Responses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteBlocklistDeleteBan2Responses, unknown, ThrowOnError>({ url: '/firewall/blocklist/{target}', ...options });
    }
    
    public static getBlocklistGetBan2<ThrowOnError extends boolean = false>(options: Options<GetBlocklistGetBan2Data, ThrowOnError>): RequestResult<GetBlocklistGetBan2Responses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetBlocklistGetBan2Responses, unknown, ThrowOnError>({ url: '/firewall/blocklist/{target}', ...options });
    }
}

export class TalkFirewallAuditApi {
    public static getFirewallAuditListAudit<ThrowOnError extends boolean = false>(options?: Options<GetFirewallAuditListAuditData, ThrowOnError>): RequestResult<GetFirewallAuditListAuditResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetFirewallAuditListAuditResponses, unknown, ThrowOnError>({ url: '/firewall/audit', ...options });
    }
}

export class TalkFpbxRegistrationsApi {
    public static getFpbxRegistrationsGetRegistrations<ThrowOnError extends boolean = false>(options?: Options<GetFpbxRegistrationsGetRegistrationsData, ThrowOnError>): RequestResult<GetFpbxRegistrationsGetRegistrationsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetFpbxRegistrationsGetRegistrationsResponses, unknown, ThrowOnError>({ url: '/fpbx/registrations', ...options });
    }
}

export class TalkAccessApi {
    public static deleteAccessDelete<ThrowOnError extends boolean = false>(options: Options<DeleteAccessDeleteData, ThrowOnError>): RequestResult<DeleteAccessDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteAccessDeleteResponses, unknown, ThrowOnError>({
            url: '/access',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getAccessIndex<ThrowOnError extends boolean = false>(options?: Options<GetAccessIndexData, ThrowOnError>): RequestResult<GetAccessIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAccessIndexResponses, unknown, ThrowOnError>({ url: '/access', ...options });
    }
    
    public static postAccessStore<ThrowOnError extends boolean = false>(options: Options<PostAccessStoreData, ThrowOnError>): RequestResult<PostAccessStoreResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAccessStoreResponses, unknown, ThrowOnError>({
            url: '/access',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getAccessGetComposite<ThrowOnError extends boolean = false>(options?: Options<GetAccessGetCompositeData, ThrowOnError>): RequestResult<GetAccessGetCompositeResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAccessGetCompositeResponses, unknown, ThrowOnError>({ url: '/access/composite', ...options });
    }
    
    public static postAccessNotifyAccessReconfigured<ThrowOnError extends boolean = false>(options: Options<PostAccessNotifyAccessReconfiguredData, ThrowOnError>): RequestResult<PostAccessNotifyAccessReconfiguredResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAccessNotifyAccessReconfiguredResponses, unknown, ThrowOnError>({
            url: '/access/notify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkNumbersApi {
    public static getNumbersList<ThrowOnError extends boolean = false>(options?: Options<GetNumbersListData, ThrowOnError>): RequestResult<GetNumbersListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetNumbersListResponses, unknown, ThrowOnError>({ url: '/numbers', ...options });
    }
    
    public static postNumbersRefreshPorting<ThrowOnError extends boolean = false>(options: Options<PostNumbersRefreshPortingData, ThrowOnError>): RequestResult<PostNumbersRefreshPortingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostNumbersRefreshPortingResponses, unknown, ThrowOnError>({ url: '/numbers/{numberId}/refresh-porting', ...options });
    }
    
    public static postNumbersProvisionTemporaryNumber<ThrowOnError extends boolean = false>(options: Options<PostNumbersProvisionTemporaryNumberData, ThrowOnError>): RequestResult<PostNumbersProvisionTemporaryNumberResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostNumbersProvisionTemporaryNumberResponses, unknown, ThrowOnError>({ url: '/numbers/{numberId}/temporary-number', ...options });
    }
    
    public static deleteNumbersDelete<ThrowOnError extends boolean = false>(options: Options<DeleteNumbersDeleteData, ThrowOnError>): RequestResult<DeleteNumbersDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteNumbersDeleteResponses, unknown, ThrowOnError>({ url: '/numbers/{numberId}', ...options });
    }
    
    public static putNumbersUpdate<ThrowOnError extends boolean = false>(options: Options<PutNumbersUpdateData, ThrowOnError>): RequestResult<PutNumbersUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutNumbersUpdateResponses, unknown, ThrowOnError>({
            url: '/numbers/{numberId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postNumbersClearEmergencyStatus<ThrowOnError extends boolean = false>(options: Options<PostNumbersClearEmergencyStatusData, ThrowOnError>): RequestResult<PostNumbersClearEmergencyStatusResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostNumbersClearEmergencyStatusResponses, unknown, ThrowOnError>({ url: '/numbers/{numberId}/clear-emergency-status', ...options });
    }
    
    public static postNumbersQueueTelnyxSync<ThrowOnError extends boolean = false>(options: Options<PostNumbersQueueTelnyxSyncData, ThrowOnError>): RequestResult<PostNumbersQueueTelnyxSyncResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostNumbersQueueTelnyxSyncResponses, unknown, ThrowOnError>({ url: '/numbers/{numberId}/queue-telnyx-sync', ...options });
    }
}

export class TalkExtensionsApi {
    public static getExtensionsListPlanTypes<ThrowOnError extends boolean = false>(options?: Options<GetExtensionsListPlanTypesData, ThrowOnError>): RequestResult<GetExtensionsListPlanTypesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetExtensionsListPlanTypesResponses, unknown, ThrowOnError>({ url: '/extensions/plan-types', ...options });
    }
    
    public static getExtensionsListExtensions<ThrowOnError extends boolean = false>(options?: Options<GetExtensionsListExtensionsData, ThrowOnError>): RequestResult<GetExtensionsListExtensionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetExtensionsListExtensionsResponses, unknown, ThrowOnError>({ url: '/extensions', ...options });
    }
    
    public static postExtensionsCreateExtension<ThrowOnError extends boolean = false>(options: Options<PostExtensionsCreateExtensionData, ThrowOnError>): RequestResult<PostExtensionsCreateExtensionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostExtensionsCreateExtensionResponses, unknown, ThrowOnError>({
            url: '/extensions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getExtensionsListDetailedExtensions<ThrowOnError extends boolean = false>(options?: Options<GetExtensionsListDetailedExtensionsData, ThrowOnError>): RequestResult<GetExtensionsListDetailedExtensionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetExtensionsListDetailedExtensionsResponses, unknown, ThrowOnError>({ url: '/extensions/detailed', ...options });
    }
    
    public static postExtensionsValidateExtension<ThrowOnError extends boolean = false>(options: Options<PostExtensionsValidateExtensionData, ThrowOnError>): RequestResult<PostExtensionsValidateExtensionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostExtensionsValidateExtensionResponses, unknown, ThrowOnError>({
            url: '/extensions/validate-extension',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postExtensionsValidatePlanChange<ThrowOnError extends boolean = false>(options: Options<PostExtensionsValidatePlanChangeData, ThrowOnError>): RequestResult<PostExtensionsValidatePlanChangeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostExtensionsValidatePlanChangeResponses, unknown, ThrowOnError>({
            url: '/extensions/{id}/validate-plan-change',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteExtensionsDeleteExtension<ThrowOnError extends boolean = false>(options: Options<DeleteExtensionsDeleteExtensionData, ThrowOnError>): RequestResult<DeleteExtensionsDeleteExtensionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteExtensionsDeleteExtensionResponses, unknown, ThrowOnError>({ url: '/extensions/{id}', ...options });
    }
    
    public static putExtensionsUpdateExtension<ThrowOnError extends boolean = false>(options: Options<PutExtensionsUpdateExtensionData, ThrowOnError>): RequestResult<PutExtensionsUpdateExtensionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutExtensionsUpdateExtensionResponses, unknown, ThrowOnError>({
            url: '/extensions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkSubscribedNumbersApi {
    public static deleteSubscribedNumbersDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSubscribedNumbersDeleteData, ThrowOnError>): RequestResult<DeleteSubscribedNumbersDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteSubscribedNumbersDeleteResponses, unknown, ThrowOnError>({
            url: '/subscribed-numbers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getSubscribedNumbersIndex<ThrowOnError extends boolean = false>(options?: Options<GetSubscribedNumbersIndexData, ThrowOnError>): RequestResult<GetSubscribedNumbersIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSubscribedNumbersIndexResponses, unknown, ThrowOnError>({ url: '/subscribed-numbers', ...options });
    }
    
    public static postSubscribedNumbersStore<ThrowOnError extends boolean = false>(options: Options<PostSubscribedNumbersStoreData, ThrowOnError>): RequestResult<PostSubscribedNumbersStoreResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSubscribedNumbersStoreResponses, unknown, ThrowOnError>({
            url: '/subscribed-numbers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkWorkstationExtensionLinksApi {
    /**
     * Admin only. Returns the tenant's links whose extension is still live.
     */
    public static getWorkstationExtensionLinksList<ThrowOnError extends boolean = false>(options?: Options<GetWorkstationExtensionLinksListData, ThrowOnError>): RequestResult<GetWorkstationExtensionLinksListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetWorkstationExtensionLinksListResponses, unknown, ThrowOnError>({ url: '/workstation-extension-links', ...options });
    }
    
    /**
     * Any identity. Reports this session's own workstation link, if any.
     */
    public static getWorkstationExtensionLinksCurrent<ThrowOnError extends boolean = false>(options?: Options<GetWorkstationExtensionLinksCurrentData, ThrowOnError>): RequestResult<GetWorkstationExtensionLinksCurrentResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetWorkstationExtensionLinksCurrentResponses, unknown, ThrowOnError>({ url: '/workstation-extension-links/current', ...options });
    }
    
    /**
     * Idempotent: returns ok even when no row exists. No Suite check, so links on deleted workstations can still be cleared.
     */
    public static deleteWorkstationExtensionLinksClear<ThrowOnError extends boolean = false>(options: Options<DeleteWorkstationExtensionLinksClearData, ThrowOnError>): RequestResult<DeleteWorkstationExtensionLinksClearResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteWorkstationExtensionLinksClearResponses, unknown, ThrowOnError>({ url: '/workstation-extension-links/{workstationId}', ...options });
    }
    
    public static putWorkstationExtensionLinksSet<ThrowOnError extends boolean = false>(options: Options<PutWorkstationExtensionLinksSetData, ThrowOnError>): RequestResult<PutWorkstationExtensionLinksSetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutWorkstationExtensionLinksSetResponses, unknown, ThrowOnError>({
            url: '/workstation-extension-links/{workstationId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkAdminHardwareOrdersApi {
    public static getAdminHardwareOrdersList<ThrowOnError extends boolean = false>(options?: Options<GetAdminHardwareOrdersListData, ThrowOnError>): RequestResult<GetAdminHardwareOrdersListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAdminHardwareOrdersListResponses, unknown, ThrowOnError>({ url: '/sa/hardware-orders', ...options });
    }
    
    public static getAdminHardwareOrdersGet<ThrowOnError extends boolean = false>(options: Options<GetAdminHardwareOrdersGetData, ThrowOnError>): RequestResult<GetAdminHardwareOrdersGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetAdminHardwareOrdersGetResponses, unknown, ThrowOnError>({ url: '/sa/hardware-orders/{id}', ...options });
    }
    
    /**
     * The one staff save: a lifecycle transition, staff reference, customer-safe note, and a complete replacement line set are each optional and commit together in one transaction.
     */
    public static patchAdminHardwareOrdersUpdate<ThrowOnError extends boolean = false>(options: Options<PatchAdminHardwareOrdersUpdateData, ThrowOnError>): RequestResult<PatchAdminHardwareOrdersUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).patch<PatchAdminHardwareOrdersUpdateResponses, unknown, ThrowOnError>({
            url: '/sa/hardware-orders/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Buys the order's equipment now instead of waiting for the daily run. Every reason it cannot be placed comes back in one message rather than one per attempt.
     */
    public static postAdminHardwareOrdersPlace<ThrowOnError extends boolean = false>(options: Options<PostAdminHardwareOrdersPlaceData, ThrowOnError>): RequestResult<PostAdminHardwareOrdersPlaceResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAdminHardwareOrdersPlaceResponses, unknown, ThrowOnError>({
            url: '/sa/hardware-orders/{id}/place',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkAdminSignupOrdersApi {
    public static getAdminSignupOrdersList<ThrowOnError extends boolean = false>(options?: Options<GetAdminSignupOrdersListData, ThrowOnError>): RequestResult<GetAdminSignupOrdersListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAdminSignupOrdersListResponses, unknown, ThrowOnError>({ url: '/sa/orders', ...options });
    }
    
    /**
     * Billing collection is fixed before signing so a public completion cannot change its commercial terms.
     */
    public static patchAdminSignupOrdersUpdateBillingBypass<ThrowOnError extends boolean = false>(options: Options<PatchAdminSignupOrdersUpdateBillingBypassData, ThrowOnError>): RequestResult<PatchAdminSignupOrdersUpdateBillingBypassResponses, unknown, ThrowOnError> {
        return (options.client ?? client).patch<PatchAdminSignupOrdersUpdateBillingBypassResponses, unknown, ThrowOnError>({
            url: '/sa/orders/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postAdminSignupOrdersReprocessOrder<ThrowOnError extends boolean = false>(options: Options<PostAdminSignupOrdersReprocessOrderData, ThrowOnError>): RequestResult<PostAdminSignupOrdersReprocessOrderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAdminSignupOrdersReprocessOrderResponses, unknown, ThrowOnError>({ url: '/sa/orders/{id}/reprocess', ...options });
    }
    
    public static postAdminSignupOrdersRetryFailedOrder<ThrowOnError extends boolean = false>(options: Options<PostAdminSignupOrdersRetryFailedOrderData, ThrowOnError>): RequestResult<PostAdminSignupOrdersRetryFailedOrderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAdminSignupOrdersRetryFailedOrderResponses, unknown, ThrowOnError>({ url: '/sa/orders/{id}/retry', ...options });
    }
}

export class TalkBillPlanAnalysisApi {
    public static postBillPlanAnalysisAnalyze<ThrowOnError extends boolean = false>(options: Options<PostBillPlanAnalysisAnalyzeData, ThrowOnError>): RequestResult<PostBillPlanAnalysisAnalyzeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostBillPlanAnalysisAnalyzeResponses, unknown, ThrowOnError>({
            ...formDataBodySerializer,
            url: '/msp/orders/plan-analysis',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}

export class TalkCatalogAdminApi {
    /**
     * Confirms a distributor SKU against the distributor's own product record before it is trusted in a catalog revision. This is a live read: nothing is persisted, and the returned cost and stock are procurement context for staff, never customer-facing catalog data.
     */
    public static postCatalogAdminValidateVendorSku<ThrowOnError extends boolean = false>(options: Options<PostCatalogAdminValidateVendorSkuData, ThrowOnError>): RequestResult<PostCatalogAdminValidateVendorSkuResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCatalogAdminValidateVendorSkuResponses, unknown, ThrowOnError>({
            url: '/sa/orders/catalog/vendor-skus/{vendor}/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCatalogAdminCreateImage<ThrowOnError extends boolean = false>(options: Options<PostCatalogAdminCreateImageData, ThrowOnError>): RequestResult<PostCatalogAdminCreateImageResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCatalogAdminCreateImageResponses, unknown, ThrowOnError>({
            url: '/sa/orders/catalog/images',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getCatalogAdminList<ThrowOnError extends boolean = false>(options?: Options<GetCatalogAdminListData, ThrowOnError>): RequestResult<GetCatalogAdminListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCatalogAdminListResponses, unknown, ThrowOnError>({ url: '/sa/orders/catalog/revisions', ...options });
    }
    
    public static postCatalogAdminCreate<ThrowOnError extends boolean = false>(options: Options<PostCatalogAdminCreateData, ThrowOnError>): RequestResult<PostCatalogAdminCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCatalogAdminCreateResponses, unknown, ThrowOnError>({
            url: '/sa/orders/catalog/revisions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getCatalogAdminGet<ThrowOnError extends boolean = false>(options: Options<GetCatalogAdminGetData, ThrowOnError>): RequestResult<GetCatalogAdminGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCatalogAdminGetResponses, unknown, ThrowOnError>({ url: '/sa/orders/catalog/revisions/{revision}', ...options });
    }
    
    public static deleteCatalogAdminDeleteItem<ThrowOnError extends boolean = false>(options: Options<DeleteCatalogAdminDeleteItemData, ThrowOnError>): RequestResult<DeleteCatalogAdminDeleteItemResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCatalogAdminDeleteItemResponses, unknown, ThrowOnError>({ url: '/sa/orders/catalog/revisions/{revision}/items/{key}', ...options });
    }
    
    public static putCatalogAdminUpsertItem<ThrowOnError extends boolean = false>(options: Options<PutCatalogAdminUpsertItemData, ThrowOnError>): RequestResult<PutCatalogAdminUpsertItemResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCatalogAdminUpsertItemResponses, unknown, ThrowOnError>({
            url: '/sa/orders/catalog/revisions/{revision}/items/{key}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putCatalogAdminUpsertVendorSku<ThrowOnError extends boolean = false>(options: Options<PutCatalogAdminUpsertVendorSkuData, ThrowOnError>): RequestResult<PutCatalogAdminUpsertVendorSkuResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCatalogAdminUpsertVendorSkuResponses, unknown, ThrowOnError>({
            url: '/sa/orders/catalog/revisions/{revision}/items/{key}/vendor-skus/{vendor}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putCatalogAdminUpsertPrice<ThrowOnError extends boolean = false>(options: Options<PutCatalogAdminUpsertPriceData, ThrowOnError>): RequestResult<PutCatalogAdminUpsertPriceResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCatalogAdminUpsertPriceResponses, unknown, ThrowOnError>({
            url: '/sa/orders/catalog/revisions/{revision}/items/{key}/prices',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCatalogAdminDeletePrice<ThrowOnError extends boolean = false>(options: Options<DeleteCatalogAdminDeletePriceData, ThrowOnError>): RequestResult<DeleteCatalogAdminDeletePriceResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCatalogAdminDeletePriceResponses, unknown, ThrowOnError>({ url: '/sa/orders/catalog/revisions/{revision}/items/{key}/prices/{chargeType}/{unit}', ...options });
    }
    
    public static putCatalogAdminUpsertRelation<ThrowOnError extends boolean = false>(options: Options<PutCatalogAdminUpsertRelationData, ThrowOnError>): RequestResult<PutCatalogAdminUpsertRelationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCatalogAdminUpsertRelationResponses, unknown, ThrowOnError>({
            url: '/sa/orders/catalog/revisions/{revision}/relations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCatalogAdminDeleteRelation<ThrowOnError extends boolean = false>(options: Options<DeleteCatalogAdminDeleteRelationData, ThrowOnError>): RequestResult<DeleteCatalogAdminDeleteRelationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCatalogAdminDeleteRelationResponses, unknown, ThrowOnError>({ url: '/sa/orders/catalog/revisions/{revision}/relations/{type}/{fromKey}/{toKey}', ...options });
    }
    
    public static postCatalogAdminValidate<ThrowOnError extends boolean = false>(options: Options<PostCatalogAdminValidateData, ThrowOnError>): RequestResult<PostCatalogAdminValidateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCatalogAdminValidateResponses, unknown, ThrowOnError>({ url: '/sa/orders/catalog/revisions/{revision}/validate', ...options });
    }
    
    public static postCatalogAdminPublish<ThrowOnError extends boolean = false>(options: Options<PostCatalogAdminPublishData, ThrowOnError>): RequestResult<PostCatalogAdminPublishResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCatalogAdminPublishResponses, unknown, ThrowOnError>({ url: '/sa/orders/catalog/revisions/{revision}/publish', ...options });
    }
}

export class TalkOrders888VoipApi {
    public static postOrders888VoipHandleWebhook<ThrowOnError extends boolean = false>(options: Options<PostOrders888VoipHandleWebhookData, ThrowOnError>): RequestResult<PostOrders888VoipHandleWebhookResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrders888VoipHandleWebhookResponses, unknown, ThrowOnError>({
            url: '/public/orders/webhooks/888voip',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkOrdersAdminApi {
    public static postOrdersAdminProvisionHardware<ThrowOnError extends boolean = false>(options: Options<PostOrdersAdminProvisionHardwareData, ThrowOnError>): RequestResult<PostOrdersAdminProvisionHardwareResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersAdminProvisionHardwareResponses, unknown, ThrowOnError>({ url: '/orders/hardware/{hardwareId}/provision', ...options });
    }
}

export class TalkMspOrdersApi {
    public static getMspOrdersList<ThrowOnError extends boolean = false>(options?: Options<GetMspOrdersListData, ThrowOnError>): RequestResult<GetMspOrdersListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMspOrdersListResponses, unknown, ThrowOnError>({ url: '/msp/orders', ...options });
    }
    
    public static getMspOrdersGet<ThrowOnError extends boolean = false>(options: Options<GetMspOrdersGetData, ThrowOnError>): RequestResult<GetMspOrdersGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetMspOrdersGetResponses, unknown, ThrowOnError>({ url: '/msp/orders/{id}', ...options });
    }
    
    /**
     * Trusted MSP attribution path. Anonymous referral data never controls `mspId` or `createdBy`.
     */
    public static postMspOrdersCreate<ThrowOnError extends boolean = false>(options: Options<PostMspOrdersCreateData, ThrowOnError>): RequestResult<PostMspOrdersCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostMspOrdersCreateResponses, unknown, ThrowOnError>({
            url: '/msp/orders/draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteMspOrdersDeleteDraft<ThrowOnError extends boolean = false>(options: Options<DeleteMspOrdersDeleteDraftData, ThrowOnError>): RequestResult<DeleteMspOrdersDeleteDraftResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMspOrdersDeleteDraftResponses, unknown, ThrowOnError>({ url: '/msp/orders/{id}/draft', ...options });
    }
    
    /**
     * Changes only the trusted existing-tenant binding; generic wizard fields stay on the public autosave endpoint.
     */
    public static patchMspOrdersUpdateExistingTenant<ThrowOnError extends boolean = false>(options: Options<PatchMspOrdersUpdateExistingTenantData, ThrowOnError>): RequestResult<PatchMspOrdersUpdateExistingTenantResponses, unknown, ThrowOnError> {
        return (options.client ?? client).patch<PatchMspOrdersUpdateExistingTenantResponses, unknown, ThrowOnError>({
            url: '/msp/orders/{id}/draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkOrdersSignupApi {
    public static postOrdersSignupHandleCreateDraft<ThrowOnError extends boolean = false>(options: Options<PostOrdersSignupHandleCreateDraftData, ThrowOnError>): RequestResult<PostOrdersSignupHandleCreateDraftResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersSignupHandleCreateDraftResponses, unknown, ThrowOnError>({
            url: '/public/orders/draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static patchOrdersSignupHandleUpdateDraft<ThrowOnError extends boolean = false>(options: Options<PatchOrdersSignupHandleUpdateDraftData, ThrowOnError>): RequestResult<PatchOrdersSignupHandleUpdateDraftResponses, unknown, ThrowOnError> {
        return (options.client ?? client).patch<PatchOrdersSignupHandleUpdateDraftResponses, unknown, ThrowOnError>({
            url: '/public/orders/{id}/draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sends the six-digit email confirmation code for the current public signup draft.
     */
    public static postOrdersSignupHandleIssueEmailVerification<ThrowOnError extends boolean = false>(options: Options<PostOrdersSignupHandleIssueEmailVerificationData, ThrowOnError>): RequestResult<PostOrdersSignupHandleIssueEmailVerificationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersSignupHandleIssueEmailVerificationResponses, unknown, ThrowOnError>({ url: '/public/orders/{id}/email-verification', ...options });
    }
    
    /**
     * Confirms the code that Suite delivered to the current draft email address.
     */
    public static postOrdersSignupHandleConfirmEmailVerification<ThrowOnError extends boolean = false>(options: Options<PostOrdersSignupHandleConfirmEmailVerificationData, ThrowOnError>): RequestResult<PostOrdersSignupHandleConfirmEmailVerificationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersSignupHandleConfirmEmailVerificationResponses, unknown, ThrowOnError>({
            url: '/public/orders/{id}/email-verification/confirm',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Server-authoritative preflight used before the browser asks Stripe to create a confirmation token. Prepare and completion validate again with the token requirement enabled.
     */
    public static postOrdersSignupValidateOrder<ThrowOnError extends boolean = false>(options: Options<PostOrdersSignupValidateOrderData, ThrowOnError>): RequestResult<PostOrdersSignupValidateOrderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersSignupValidateOrderResponses, unknown, ThrowOnError>({
            url: '/public/orders/validate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postOrdersSignupHandlePrepareOrder<ThrowOnError extends boolean = false>(options: Options<PostOrdersSignupHandlePrepareOrderData, ThrowOnError>): RequestResult<PostOrdersSignupHandlePrepareOrderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersSignupHandlePrepareOrderResponses, unknown, ThrowOnError>({
            url: '/public/orders/{id}/prepare',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getOrdersSignupGetAgreement<ThrowOnError extends boolean = false>(options: Options<GetOrdersSignupGetAgreementData, ThrowOnError>): RequestResult<GetOrdersSignupGetAgreementResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetOrdersSignupGetAgreementResponses, unknown, ThrowOnError>({ url: '/public/orders/{id}/agreement', ...options });
    }
    
    public static getOrdersSignupGetOrder<ThrowOnError extends boolean = false>(options: Options<GetOrdersSignupGetOrderData, ThrowOnError>): RequestResult<GetOrdersSignupGetOrderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetOrdersSignupGetOrderResponses, unknown, ThrowOnError>({ url: '/public/orders/{id}', ...options });
    }
    
    public static postOrdersSignupHandleComplete<ThrowOnError extends boolean = false>(options: Options<PostOrdersSignupHandleCompleteData, ThrowOnError>): RequestResult<PostOrdersSignupHandleCompleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersSignupHandleCompleteResponses, unknown, ThrowOnError>({
            url: '/public/orders/{id}/complete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Attach a browser-confirmed payment method as soon as the customer enters their card.
     */
    public static postOrdersSignupHandlePaymentMethod<ThrowOnError extends boolean = false>(options: Options<PostOrdersSignupHandlePaymentMethodData, ThrowOnError>): RequestResult<PostOrdersSignupHandlePaymentMethodResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersSignupHandlePaymentMethodResponses, unknown, ThrowOnError>({
            url: '/public/orders/{id}/payment-method',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postOrdersSignupHandleUpdatePayment<ThrowOnError extends boolean = false>(options: Options<PostOrdersSignupHandleUpdatePaymentData, ThrowOnError>): RequestResult<PostOrdersSignupHandleUpdatePaymentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersSignupHandleUpdatePaymentResponses, unknown, ThrowOnError>({
            url: '/public/orders/{id}/update-payment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkOrdersTeledynamicsApi {
    public static postOrdersTeledynamicsHandleWebhook<ThrowOnError extends boolean = false>(options: Options<PostOrdersTeledynamicsHandleWebhookData, ThrowOnError>): RequestResult<PostOrdersTeledynamicsHandleWebhookResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostOrdersTeledynamicsHandleWebhookResponses, unknown, ThrowOnError>({
            url: '/public/orders/webhooks/teledynamics',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkPublicCatalogApi {
    public static getPublicCatalogGetCatalog<ThrowOnError extends boolean = false>(options?: Options<GetPublicCatalogGetCatalogData, ThrowOnError>): RequestResult<GetPublicCatalogGetCatalogResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetPublicCatalogGetCatalogResponses, unknown, ThrowOnError>({ url: '/public/orders/catalog', ...options });
    }
}

export class TalkTenantHardwareOrdersApi {
    public static getTenantHardwareOrdersCatalog<ThrowOnError extends boolean = false>(options?: Options<GetTenantHardwareOrdersCatalogData, ThrowOnError>): RequestResult<GetTenantHardwareOrdersCatalogResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantHardwareOrdersCatalogResponses, unknown, ThrowOnError>({ url: '/orders/hardware/catalog', ...options });
    }
    
    public static postTenantHardwareOrdersQuote<ThrowOnError extends boolean = false>(options: Options<PostTenantHardwareOrdersQuoteData, ThrowOnError>): RequestResult<PostTenantHardwareOrdersQuoteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantHardwareOrdersQuoteResponses, unknown, ThrowOnError>({
            url: '/orders/hardware/quote',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getTenantHardwareOrdersList<ThrowOnError extends boolean = false>(options?: Options<GetTenantHardwareOrdersListData, ThrowOnError>): RequestResult<GetTenantHardwareOrdersListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantHardwareOrdersListResponses, unknown, ThrowOnError>({ url: '/orders/hardware', ...options });
    }
    
    public static postTenantHardwareOrdersSubmit<ThrowOnError extends boolean = false>(options: Options<PostTenantHardwareOrdersSubmitData, ThrowOnError>): RequestResult<PostTenantHardwareOrdersSubmitResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantHardwareOrdersSubmitResponses, unknown, ThrowOnError>({
            url: '/orders/hardware',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Supplies shipping and moves an approved public-signup order into the normal fulfillment queue.
     */
    public static postTenantHardwareOrdersSubmitPreSubmitted<ThrowOnError extends boolean = false>(options: Options<PostTenantHardwareOrdersSubmitPreSubmittedData, ThrowOnError>): RequestResult<PostTenantHardwareOrdersSubmitPreSubmittedResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantHardwareOrdersSubmitPreSubmittedResponses, unknown, ThrowOnError>({
            url: '/orders/hardware/{id}/submit',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Phones the tenant has received but not yet added as endpoints.
     */
    public static getTenantHardwareOrdersUnlinkedDevices<ThrowOnError extends boolean = false>(options?: Options<GetTenantHardwareOrdersUnlinkedDevicesData, ThrowOnError>): RequestResult<GetTenantHardwareOrdersUnlinkedDevicesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantHardwareOrdersUnlinkedDevicesResponses, unknown, ThrowOnError>({ url: '/orders/hardware/unlinked-devices', ...options });
    }
    
    public static getTenantHardwareOrdersGet<ThrowOnError extends boolean = false>(options: Options<GetTenantHardwareOrdersGetData, ThrowOnError>): RequestResult<GetTenantHardwareOrdersGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetTenantHardwareOrdersGetResponses, unknown, ThrowOnError>({ url: '/orders/hardware/{id}', ...options });
    }
    
    public static postTenantHardwareOrdersCancel<ThrowOnError extends boolean = false>(options: Options<PostTenantHardwareOrdersCancelData, ThrowOnError>): RequestResult<PostTenantHardwareOrdersCancelResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantHardwareOrdersCancelResponses, unknown, ThrowOnError>({ url: '/orders/hardware/{id}/cancel', ...options });
    }
}

export class TalkTenantOverviewApi {
    public static getTenantOverviewGet<ThrowOnError extends boolean = false>(options?: Options<GetTenantOverviewGetData, ThrowOnError>): RequestResult<GetTenantOverviewGetResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantOverviewGetResponses, unknown, ThrowOnError>({ url: '/overview', ...options });
    }
    
    /**
     * The customer confirming the boxes arrived. Device registration completes an order on its own, so this is for the equipment nobody will register — cables, spares, a phone kept in a drawer.
     */
    public static postTenantOverviewMarkReceived<ThrowOnError extends boolean = false>(options: Options<PostTenantOverviewMarkReceivedData, ThrowOnError>): RequestResult<PostTenantOverviewMarkReceivedResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantOverviewMarkReceivedResponses, unknown, ThrowOnError>({ url: '/overview/orders/{id}/mark-received', ...options });
    }
    
    public static deleteTenantOverviewCancelNumberIntent<ThrowOnError extends boolean = false>(options: Options<DeleteTenantOverviewCancelNumberIntentData, ThrowOnError>): RequestResult<DeleteTenantOverviewCancelNumberIntentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTenantOverviewCancelNumberIntentResponses, unknown, ThrowOnError>({ url: '/overview/intents/{intentKey}', ...options });
    }
}

export class TalkReportsApi {
    public static getReportsCallsByExtension<ThrowOnError extends boolean = false>(options: Options<GetReportsCallsByExtensionData, ThrowOnError>): RequestResult<GetReportsCallsByExtensionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetReportsCallsByExtensionResponses, unknown, ThrowOnError>({ url: '/reports/calls-by-extension', ...options });
    }
    
    public static getReportsCallsByNumber<ThrowOnError extends boolean = false>(options: Options<GetReportsCallsByNumberData, ThrowOnError>): RequestResult<GetReportsCallsByNumberResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetReportsCallsByNumberResponses, unknown, ThrowOnError>({ url: '/reports/calls-by-number', ...options });
    }
    
    public static getReportsFaxByNumber<ThrowOnError extends boolean = false>(options: Options<GetReportsFaxByNumberData, ThrowOnError>): RequestResult<GetReportsFaxByNumberResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetReportsFaxByNumberResponses, unknown, ThrowOnError>({ url: '/reports/fax-by-number', ...options });
    }
    
    public static getReportsSmsByNumber<ThrowOnError extends boolean = false>(options: Options<GetReportsSmsByNumberData, ThrowOnError>): RequestResult<GetReportsSmsByNumberResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetReportsSmsByNumberResponses, unknown, ThrowOnError>({ url: '/reports/sms-by-number', ...options });
    }
    
    public static getReportsCallsByDate<ThrowOnError extends boolean = false>(options: Options<GetReportsCallsByDateData, ThrowOnError>): RequestResult<GetReportsCallsByDateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetReportsCallsByDateResponses, unknown, ThrowOnError>({ url: '/reports/calls-by-date', ...options });
    }
    
    public static getReportsFaxByDate<ThrowOnError extends boolean = false>(options: Options<GetReportsFaxByDateData, ThrowOnError>): RequestResult<GetReportsFaxByDateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetReportsFaxByDateResponses, unknown, ThrowOnError>({ url: '/reports/fax-by-date', ...options });
    }
    
    public static getReportsSmsByDate<ThrowOnError extends boolean = false>(options: Options<GetReportsSmsByDateData, ThrowOnError>): RequestResult<GetReportsSmsByDateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetReportsSmsByDateResponses, unknown, ThrowOnError>({ url: '/reports/sms-by-date', ...options });
    }
}

export class TalkSmsBrandsApi {
    public static getSmsBrandsList<ThrowOnError extends boolean = false>(options?: Options<GetSmsBrandsListData, ThrowOnError>): RequestResult<GetSmsBrandsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSmsBrandsListResponses, unknown, ThrowOnError>({ url: '/sms/brands', ...options });
    }
    
    public static postSmsBrandsCreate<ThrowOnError extends boolean = false>(options: Options<PostSmsBrandsCreateData, ThrowOnError>): RequestResult<PostSmsBrandsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsBrandsCreateResponses, unknown, ThrowOnError>({
            url: '/sms/brands',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Static Telnyx-supported values for a tenant-admin brand-submission form.
     */
    public static getSmsBrandsVerticals<ThrowOnError extends boolean = false>(options?: Options<GetSmsBrandsVerticalsData, ThrowOnError>): RequestResult<GetSmsBrandsVerticalsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSmsBrandsVerticalsResponses, unknown, ThrowOnError>({ url: '/sms/brands/verticals', ...options });
    }
    
    public static getSmsBrandsGet<ThrowOnError extends boolean = false>(options: Options<GetSmsBrandsGetData, ThrowOnError>): RequestResult<GetSmsBrandsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSmsBrandsGetResponses, unknown, ThrowOnError>({ url: '/sms/brands/{id}', ...options });
    }
    
    /**
     * Tenants can correct a request until a system administrator begins processing it.
     */
    public static putSmsBrandsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSmsBrandsUpdateData, ThrowOnError>): RequestResult<PutSmsBrandsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSmsBrandsUpdateResponses, unknown, ThrowOnError>({
            url: '/sms/brands/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkSmsRegistrationsAdminApi {
    public static getSmsRegistrationsAdminBrands<ThrowOnError extends boolean = false>(options?: Options<GetSmsRegistrationsAdminBrandsData, ThrowOnError>): RequestResult<GetSmsRegistrationsAdminBrandsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSmsRegistrationsAdminBrandsResponses, unknown, ThrowOnError>({ url: '/sa/sms/brands', ...options });
    }
    
    public static getSmsRegistrationsAdminBrand<ThrowOnError extends boolean = false>(options: Options<GetSmsRegistrationsAdminBrandData, ThrowOnError>): RequestResult<GetSmsRegistrationsAdminBrandResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSmsRegistrationsAdminBrandResponses, unknown, ThrowOnError>({ url: '/sa/sms/brands/{brandId}', ...options });
    }
    
    public static getSmsRegistrationsAdminRequests<ThrowOnError extends boolean = false>(options?: Options<GetSmsRegistrationsAdminRequestsData, ThrowOnError>): RequestResult<GetSmsRegistrationsAdminRequestsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSmsRegistrationsAdminRequestsResponses, unknown, ThrowOnError>({ url: '/sa/sms/requests', ...options });
    }
    
    public static getSmsRegistrationsAdminCampaign<ThrowOnError extends boolean = false>(options: Options<GetSmsRegistrationsAdminCampaignData, ThrowOnError>): RequestResult<GetSmsRegistrationsAdminCampaignResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSmsRegistrationsAdminCampaignResponses, unknown, ThrowOnError>({ url: '/sa/sms/campaigns/{campaignId}', ...options });
    }
    
    public static putSmsRegistrationsAdminUpdateCampaignMessaging<ThrowOnError extends boolean = false>(options: Options<PutSmsRegistrationsAdminUpdateCampaignMessagingData, ThrowOnError>): RequestResult<PutSmsRegistrationsAdminUpdateCampaignMessagingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSmsRegistrationsAdminUpdateCampaignMessagingResponses, unknown, ThrowOnError>({
            url: '/sa/sms/campaigns/{campaignId}/messaging',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkSmsTelnyxRegistrationsAdminApi {
    public static getSmsTelnyxRegistrationsAdminBrands<ThrowOnError extends boolean = false>(options?: Options<GetSmsTelnyxRegistrationsAdminBrandsData, ThrowOnError>): RequestResult<GetSmsTelnyxRegistrationsAdminBrandsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSmsTelnyxRegistrationsAdminBrandsResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/brands', ...options });
    }
    
    public static getSmsTelnyxRegistrationsAdminCampaigns<ThrowOnError extends boolean = false>(options: Options<GetSmsTelnyxRegistrationsAdminCampaignsData, ThrowOnError>): RequestResult<GetSmsTelnyxRegistrationsAdminCampaignsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSmsTelnyxRegistrationsAdminCampaignsResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/brands/{brandId}/campaigns', ...options });
    }
    
    /**
     * Create a local campaign plus its reviewed Telnyx registration draft.
     */
    public static postSmsTelnyxRegistrationsAdminCreateCampaign<ThrowOnError extends boolean = false>(options: Options<PostSmsTelnyxRegistrationsAdminCreateCampaignData, ThrowOnError>): RequestResult<PostSmsTelnyxRegistrationsAdminCreateCampaignResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsTelnyxRegistrationsAdminCreateCampaignResponses, unknown, ThrowOnError>({
            url: '/sa/sms/telnyx/brands/{brandId}/campaigns',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Live Telnyx catalog and sub-use-case rules for the campaign-registration form.
     */
    public static getSmsTelnyxRegistrationsAdminCampaignUsecases<ThrowOnError extends boolean = false>(options: Options<GetSmsTelnyxRegistrationsAdminCampaignUsecasesData, ThrowOnError>): RequestResult<GetSmsTelnyxRegistrationsAdminCampaignUsecasesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSmsTelnyxRegistrationsAdminCampaignUsecasesResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/campaign-usecases', ...options });
    }
    
    /**
     * Global reusable form prefills for system-admin campaign registrations.
     */
    public static getSmsTelnyxRegistrationsAdminCampaignRegistrationTemplates<ThrowOnError extends boolean = false>(options?: Options<GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplatesData, ThrowOnError>): RequestResult<GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplatesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplatesResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/campaign-registration-templates', ...options });
    }
    
    public static postSmsTelnyxRegistrationsAdminCreateCampaignRegistrationTemplate<ThrowOnError extends boolean = false>(options: Options<PostSmsTelnyxRegistrationsAdminCreateCampaignRegistrationTemplateData, ThrowOnError>): RequestResult<PostSmsTelnyxRegistrationsAdminCreateCampaignRegistrationTemplateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsTelnyxRegistrationsAdminCreateCampaignRegistrationTemplateResponses, unknown, ThrowOnError>({
            url: '/sa/sms/telnyx/campaign-registration-templates',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteSmsTelnyxRegistrationsAdminDeleteCampaignRegistrationTemplate<ThrowOnError extends boolean = false>(options: Options<DeleteSmsTelnyxRegistrationsAdminDeleteCampaignRegistrationTemplateData, ThrowOnError>): RequestResult<DeleteSmsTelnyxRegistrationsAdminDeleteCampaignRegistrationTemplateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteSmsTelnyxRegistrationsAdminDeleteCampaignRegistrationTemplateResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/campaign-registration-templates/{templateId}', ...options });
    }
    
    public static getSmsTelnyxRegistrationsAdminCampaignRegistrationTemplate<ThrowOnError extends boolean = false>(options: Options<GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplateData, ThrowOnError>): RequestResult<GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSmsTelnyxRegistrationsAdminCampaignRegistrationTemplateResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/campaign-registration-templates/{templateId}', ...options });
    }
    
    public static putSmsTelnyxRegistrationsAdminUpdateCampaignRegistrationTemplate<ThrowOnError extends boolean = false>(options: Options<PutSmsTelnyxRegistrationsAdminUpdateCampaignRegistrationTemplateData, ThrowOnError>): RequestResult<PutSmsTelnyxRegistrationsAdminUpdateCampaignRegistrationTemplateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSmsTelnyxRegistrationsAdminUpdateCampaignRegistrationTemplateResponses, unknown, ThrowOnError>({
            url: '/sa/sms/telnyx/campaign-registration-templates/{templateId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getSmsTelnyxRegistrationsAdminBindings<ThrowOnError extends boolean = false>(options?: Options<GetSmsTelnyxRegistrationsAdminBindingsData, ThrowOnError>): RequestResult<GetSmsTelnyxRegistrationsAdminBindingsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSmsTelnyxRegistrationsAdminBindingsResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/bindings', ...options });
    }
    
    public static putSmsTelnyxRegistrationsAdminBindBrand<ThrowOnError extends boolean = false>(options: Options<PutSmsTelnyxRegistrationsAdminBindBrandData, ThrowOnError>): RequestResult<PutSmsTelnyxRegistrationsAdminBindBrandResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSmsTelnyxRegistrationsAdminBindBrandResponses, unknown, ThrowOnError>({
            url: '/sa/sms/telnyx/tenants/{tenantId}/brand',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putSmsTelnyxRegistrationsAdminBindCampaign<ThrowOnError extends boolean = false>(options: Options<PutSmsTelnyxRegistrationsAdminBindCampaignData, ThrowOnError>): RequestResult<PutSmsTelnyxRegistrationsAdminBindCampaignResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSmsTelnyxRegistrationsAdminBindCampaignResponses, unknown, ThrowOnError>({
            url: '/sa/sms/telnyx/tenants/{tenantId}/campaign',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Manual recovery path for campaign activation when a provider notification is delayed or unavailable.
     */
    public static postSmsTelnyxRegistrationsAdminRefreshBindings<ThrowOnError extends boolean = false>(options?: Options<PostSmsTelnyxRegistrationsAdminRefreshBindingsData, ThrowOnError>): RequestResult<PostSmsTelnyxRegistrationsAdminRefreshBindingsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostSmsTelnyxRegistrationsAdminRefreshBindingsResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/refresh-bindings', ...options });
    }
    
    /**
     * Save the exact Telnyx brand submission a system administrator has reviewed.
     */
    public static putSmsTelnyxRegistrationsAdminSetBrandRegistration<ThrowOnError extends boolean = false>(options: Options<PutSmsTelnyxRegistrationsAdminSetBrandRegistrationData, ThrowOnError>): RequestResult<PutSmsTelnyxRegistrationsAdminSetBrandRegistrationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSmsTelnyxRegistrationsAdminSetBrandRegistrationResponses, unknown, ThrowOnError>({
            url: '/sa/sms/telnyx/brands/{brandId}/registration',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Claims a requested brand for operations and makes the tenant's submission immutable.
     */
    public static postSmsTelnyxRegistrationsAdminMarkBrandProcessing<ThrowOnError extends boolean = false>(options: Options<PostSmsTelnyxRegistrationsAdminMarkBrandProcessingData, ThrowOnError>): RequestResult<PostSmsTelnyxRegistrationsAdminMarkBrandProcessingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsTelnyxRegistrationsAdminMarkBrandProcessingResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/brands/{brandId}/processing', ...options });
    }
    
    /**
     * Submit one previously reviewed brand to Telnyx.
     */
    public static postSmsTelnyxRegistrationsAdminSubmitBrand<ThrowOnError extends boolean = false>(options: Options<PostSmsTelnyxRegistrationsAdminSubmitBrandData, ThrowOnError>): RequestResult<PostSmsTelnyxRegistrationsAdminSubmitBrandResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsTelnyxRegistrationsAdminSubmitBrandResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/brands/{brandId}/submit', ...options });
    }
    
    public static putSmsTelnyxRegistrationsAdminUpdateCampaign<ThrowOnError extends boolean = false>(options: Options<PutSmsTelnyxRegistrationsAdminUpdateCampaignData, ThrowOnError>): RequestResult<PutSmsTelnyxRegistrationsAdminUpdateCampaignResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSmsTelnyxRegistrationsAdminUpdateCampaignResponses, unknown, ThrowOnError>({
            url: '/sa/sms/telnyx/campaigns/{campaignId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Submit one previously reviewed campaign registration to Telnyx.
     */
    public static postSmsTelnyxRegistrationsAdminSubmitCampaignRegistration<ThrowOnError extends boolean = false>(options: Options<PostSmsTelnyxRegistrationsAdminSubmitCampaignRegistrationData, ThrowOnError>): RequestResult<PostSmsTelnyxRegistrationsAdminSubmitCampaignRegistrationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsTelnyxRegistrationsAdminSubmitCampaignRegistrationResponses, unknown, ThrowOnError>({ url: '/sa/sms/telnyx/campaign-registrations/{registrationId}/submit', ...options });
    }
}

export class TalkSmsConversationsApi {
    public static getSmsConversationsListConversations<ThrowOnError extends boolean = false>(options?: Options<GetSmsConversationsListConversationsData, ThrowOnError>): RequestResult<GetSmsConversationsListConversationsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSmsConversationsListConversationsResponses, unknown, ThrowOnError>({ url: '/sms/conversations', ...options });
    }
    
    public static postSmsConversationsNewConversation<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsNewConversationData, ThrowOnError>): RequestResult<PostSmsConversationsNewConversationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsConversationsNewConversationResponses, unknown, ThrowOnError>({
            url: '/sms/conversations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getSmsConversationsGetConversation<ThrowOnError extends boolean = false>(options: Options<GetSmsConversationsGetConversationData, ThrowOnError>): RequestResult<GetSmsConversationsGetConversationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSmsConversationsGetConversationResponses, unknown, ThrowOnError>({ url: '/sms/conversations/{id}', ...options });
    }
    
    public static getSmsConversationsGetMessages<ThrowOnError extends boolean = false>(options: Options<GetSmsConversationsGetMessagesData, ThrowOnError>): RequestResult<GetSmsConversationsGetMessagesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSmsConversationsGetMessagesResponses, unknown, ThrowOnError>({ url: '/sms/conversations/{conversationId}/messages', ...options });
    }
    
    public static postSmsConversationsContinueConversation<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsContinueConversationData, ThrowOnError>): RequestResult<PostSmsConversationsContinueConversationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsConversationsContinueConversationResponses, unknown, ThrowOnError>({
            url: '/sms/conversations/{conversationId}/messages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postSmsConversationsMarkMessageRead<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsMarkMessageReadData, ThrowOnError>): RequestResult<PostSmsConversationsMarkMessageReadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsConversationsMarkMessageReadResponses, unknown, ThrowOnError>({ url: '/sms/conversations/{conversationId}/messages/{messageId}/read', ...options });
    }
    
    public static postSmsConversationsMarkMessageUnread<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsMarkMessageUnreadData, ThrowOnError>): RequestResult<PostSmsConversationsMarkMessageUnreadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsConversationsMarkMessageUnreadResponses, unknown, ThrowOnError>({ url: '/sms/conversations/{conversationId}/messages/{messageId}/unread', ...options });
    }
    
    public static postSmsConversationsArchiveConversation<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsArchiveConversationData, ThrowOnError>): RequestResult<PostSmsConversationsArchiveConversationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsConversationsArchiveConversationResponses, unknown, ThrowOnError>({ url: '/sms/conversations/{conversationId}/archive', ...options });
    }
    
    public static postSmsConversationsUnarchiveConversation<ThrowOnError extends boolean = false>(options: Options<PostSmsConversationsUnarchiveConversationData, ThrowOnError>): RequestResult<PostSmsConversationsUnarchiveConversationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSmsConversationsUnarchiveConversationResponses, unknown, ThrowOnError>({ url: '/sms/conversations/{conversationId}/unarchive', ...options });
    }
}

export class TalkSimulatedInboundSmsApi {
    public static postSimulatedInboundSmsReceive<ThrowOnError extends boolean = false>(options: Options<PostSimulatedInboundSmsReceiveData, ThrowOnError>): RequestResult<PostSimulatedInboundSmsReceiveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSimulatedInboundSmsReceiveResponses, unknown, ThrowOnError>({
            url: '/sms/simulated-replies',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkInboundTelnyxSmsApi {
    public static postInboundTelnyxSmsHandle<ThrowOnError extends boolean = false>(options: Options<PostInboundTelnyxSmsHandleData, ThrowOnError>): RequestResult<PostInboundTelnyxSmsHandleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostInboundTelnyxSmsHandleResponses, unknown, ThrowOnError>({
            url: '/public/sms/inbound/telnyx',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkInboundFlowrouteSmsApi {
    public static postInboundFlowrouteSmsHandle<ThrowOnError extends boolean = false>(options: Options<PostInboundFlowrouteSmsHandleData, ThrowOnError>): RequestResult<PostInboundFlowrouteSmsHandleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostInboundFlowrouteSmsHandleResponses, unknown, ThrowOnError>({
            url: '/public/sms/inbound/flowroute',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postInboundFlowrouteSmsHandleKeyed<ThrowOnError extends boolean = false>(options: Options<PostInboundFlowrouteSmsHandleKeyedData, ThrowOnError>): RequestResult<PostInboundFlowrouteSmsHandleKeyedResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostInboundFlowrouteSmsHandleKeyedResponses, unknown, ThrowOnError>({
            url: '/public/sms/inbound/flowroute/{webhookKey}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkInboundTwilioSmsApi {
    public static postInboundTwilioSmsHandle<ThrowOnError extends boolean = false>(options: Options<PostInboundTwilioSmsHandleData, ThrowOnError>): RequestResult<PostInboundTwilioSmsHandleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostInboundTwilioSmsHandleResponses, unknown, ThrowOnError>({
            url: '/public/sms/inbound/twilio',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkTwilioSmsStatusApi {
    public static postTwilioSmsStatusHandle<ThrowOnError extends boolean = false>(options: Options<PostTwilioSmsStatusHandleData, ThrowOnError>): RequestResult<PostTwilioSmsStatusHandleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTwilioSmsStatusHandleResponses, unknown, ThrowOnError>({
            url: '/public/sms/dlr/twilio',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkInboundSignalwireSmsApi {
    public static postInboundSignalwireSmsHandle<ThrowOnError extends boolean = false>(options: Options<PostInboundSignalwireSmsHandleData, ThrowOnError>): RequestResult<PostInboundSignalwireSmsHandleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostInboundSignalwireSmsHandleResponses, unknown, ThrowOnError>({
            url: '/public/sms/inbound/signalwire',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkSignalwireSmsStatusApi {
    public static postSignalwireSmsStatusHandle<ThrowOnError extends boolean = false>(options: Options<PostSignalwireSmsStatusHandleData, ThrowOnError>): RequestResult<PostSignalwireSmsStatusHandleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSignalwireSmsStatusHandleResponses, unknown, ThrowOnError>({
            url: '/public/sms/dlr/signalwire',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkSoftphoneApi {
    public static postSoftphoneGenerateConnectionToken<ThrowOnError extends boolean = false>(options?: Options<PostSoftphoneGenerateConnectionTokenData, ThrowOnError>): RequestResult<PostSoftphoneGenerateConnectionTokenResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostSoftphoneGenerateConnectionTokenResponses, unknown, ThrowOnError>({ url: '/softphone/generate-connection-token', ...options });
    }
    
    public static postSoftphoneGenerateExtensionToken<ThrowOnError extends boolean = false>(options: Options<PostSoftphoneGenerateExtensionTokenData, ThrowOnError>): RequestResult<PostSoftphoneGenerateExtensionTokenResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSoftphoneGenerateExtensionTokenResponses, unknown, ThrowOnError>({
            url: '/softphone/generate-extension-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Authorizes an exact live-listen placement within the token's short lifetime. Recording access is the user/account permission boundary; the ordinary extension token remains the source-extension authorization boundary on cPlaceCall.
     */
    public static postSoftphoneGenerateListenToken<ThrowOnError extends boolean = false>(options: Options<PostSoftphoneGenerateListenTokenData, ThrowOnError>): RequestResult<PostSoftphoneGenerateListenTokenResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSoftphoneGenerateListenTokenResponses, unknown, ThrowOnError>({
            url: '/softphone/generate-listen-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postSoftphoneCallViaDeskPhone<ThrowOnError extends boolean = false>(options: Options<PostSoftphoneCallViaDeskPhoneData, ThrowOnError>): RequestResult<PostSoftphoneCallViaDeskPhoneResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSoftphoneCallViaDeskPhoneResponses, unknown, ThrowOnError>({
            url: '/softphone/call-via-desk-phone',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkTenantUsageApi {
    public static getTenantUsageGetUsage<ThrowOnError extends boolean = false>(options?: Options<GetTenantUsageGetUsageData, ThrowOnError>): RequestResult<GetTenantUsageGetUsageResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantUsageGetUsageResponses, unknown, ThrowOnError>({ url: '/tenant/usage', ...options });
    }
}

export class TalkUploadsApi {
    public static postUploadsUpload<ThrowOnError extends boolean = false>(options: Options<PostUploadsUploadData, ThrowOnError>): RequestResult<PostUploadsUploadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostUploadsUploadResponses, unknown, ThrowOnError>({
            ...formDataBodySerializer,
            url: '/media/uploads',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    public static postUploadsUploadFromUrl<ThrowOnError extends boolean = false>(options: Options<PostUploadsUploadFromUrlData, ThrowOnError>): RequestResult<PostUploadsUploadFromUrlResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostUploadsUploadFromUrlResponses, unknown, ThrowOnError>({
            url: '/media/uploads/from-url',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getUploadsGetUrl<ThrowOnError extends boolean = false>(options: Options<GetUploadsGetUrlData, ThrowOnError>): RequestResult<GetUploadsGetUrlResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetUploadsGetUrlResponses, unknown, ThrowOnError>({ url: '/media/uploads/{id}', ...options });
    }
    
    public static getUploadsGetTranscription<ThrowOnError extends boolean = false>(options: Options<GetUploadsGetTranscriptionData, ThrowOnError>): RequestResult<GetUploadsGetTranscriptionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetUploadsGetTranscriptionResponses, unknown, ThrowOnError>({ url: '/media/uploads/{id}/transcription', ...options });
    }
    
    public static getUploadsGetContent<ThrowOnError extends boolean = false>(options: Options<GetUploadsGetContentData, ThrowOnError>): RequestResult<GetUploadsGetContentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetUploadsGetContentResponses, unknown, ThrowOnError>({ url: '/media/uploads/{id}/content', ...options });
    }
}

export class TalkTtsRenderApi {
    public static getTtsRenderGetCatalog<ThrowOnError extends boolean = false>(options?: Options<GetTtsRenderGetCatalogData, ThrowOnError>): RequestResult<GetTtsRenderGetCatalogResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTtsRenderGetCatalogResponses, unknown, ThrowOnError>({ url: '/media/tts/catalog', ...options });
    }
    
    public static getTtsRenderRender<ThrowOnError extends boolean = false>(options: Options<GetTtsRenderRenderData, ThrowOnError>): RequestResult<GetTtsRenderRenderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetTtsRenderRenderResponses, unknown, ThrowOnError>({ url: '/media/tts', ...options });
    }
}

export class TalkReferencesApi {
    public static getReferencesListReferences<ThrowOnError extends boolean = false>(options: Options<GetReferencesListReferencesData, ThrowOnError>): RequestResult<GetReferencesListReferencesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetReferencesListReferencesResponses, unknown, ThrowOnError>({ url: '/call-flow/references/{targetType}/{targetId}', ...options });
    }
}

export class TalkGreetingsApi {
    public static getGreetingsListGreetings<ThrowOnError extends boolean = false>(options?: Options<GetGreetingsListGreetingsData, ThrowOnError>): RequestResult<GetGreetingsListGreetingsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetGreetingsListGreetingsResponses, unknown, ThrowOnError>({ url: '/media/greetings', ...options });
    }
    
    public static postGreetingsCreateGreeting<ThrowOnError extends boolean = false>(options: Options<PostGreetingsCreateGreetingData, ThrowOnError>): RequestResult<PostGreetingsCreateGreetingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostGreetingsCreateGreetingResponses, unknown, ThrowOnError>({
            url: '/media/greetings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getGreetingsGetContent<ThrowOnError extends boolean = false>(options: Options<GetGreetingsGetContentData, ThrowOnError>): RequestResult<GetGreetingsGetContentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetGreetingsGetContentResponses, unknown, ThrowOnError>({ url: '/media/greetings/{id}/content', ...options });
    }
    
    public static deleteGreetingsDeleteGreeting<ThrowOnError extends boolean = false>(options: Options<DeleteGreetingsDeleteGreetingData, ThrowOnError>): RequestResult<DeleteGreetingsDeleteGreetingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteGreetingsDeleteGreetingResponses, unknown, ThrowOnError>({ url: '/media/greetings/{id}', ...options });
    }
    
    public static putGreetingsUpdateGreeting<ThrowOnError extends boolean = false>(options: Options<PutGreetingsUpdateGreetingData, ThrowOnError>): RequestResult<PutGreetingsUpdateGreetingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutGreetingsUpdateGreetingResponses, unknown, ThrowOnError>({
            url: '/media/greetings/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkHoldMusicApi {
    public static getHoldMusicListHoldMusic<ThrowOnError extends boolean = false>(options?: Options<GetHoldMusicListHoldMusicData, ThrowOnError>): RequestResult<GetHoldMusicListHoldMusicResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetHoldMusicListHoldMusicResponses, unknown, ThrowOnError>({ url: '/media/hold-music', ...options });
    }
    
    public static postHoldMusicCreateHoldMusic<ThrowOnError extends boolean = false>(options: Options<PostHoldMusicCreateHoldMusicData, ThrowOnError>): RequestResult<PostHoldMusicCreateHoldMusicResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostHoldMusicCreateHoldMusicResponses, unknown, ThrowOnError>({
            url: '/media/hold-music',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getHoldMusicGetContent<ThrowOnError extends boolean = false>(options: Options<GetHoldMusicGetContentData, ThrowOnError>): RequestResult<GetHoldMusicGetContentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetHoldMusicGetContentResponses, unknown, ThrowOnError>({ url: '/media/hold-music/{id}/content', ...options });
    }
    
    public static deleteHoldMusicDeleteHoldMusic<ThrowOnError extends boolean = false>(options: Options<DeleteHoldMusicDeleteHoldMusicData, ThrowOnError>): RequestResult<DeleteHoldMusicDeleteHoldMusicResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteHoldMusicDeleteHoldMusicResponses, unknown, ThrowOnError>({ url: '/media/hold-music/{id}', ...options });
    }
    
    public static putHoldMusicUpdateHoldMusic<ThrowOnError extends boolean = false>(options: Options<PutHoldMusicUpdateHoldMusicData, ThrowOnError>): RequestResult<PutHoldMusicUpdateHoldMusicResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutHoldMusicUpdateHoldMusicResponses, unknown, ThrowOnError>({
            url: '/media/hold-music/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TalkMediaPlaybackApi {
    public static getMediaPlaybackGet<ThrowOnError extends boolean = false>(options: Options<GetMediaPlaybackGetData, ThrowOnError>): RequestResult<GetMediaPlaybackGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetMediaPlaybackGetResponses, unknown, ThrowOnError>({ url: '/public/media/playback/{capability}', ...options });
    }
}

export class TalkVoicemailApi {
    public static getVoicemailIndex<ThrowOnError extends boolean = false>(options?: Options<GetVoicemailIndexData, ThrowOnError>): RequestResult<GetVoicemailIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetVoicemailIndexResponses, unknown, ThrowOnError>({ url: '/voicemail', ...options });
    }
    
    public static getVoicemailGetCounts<ThrowOnError extends boolean = false>(options?: Options<GetVoicemailGetCountsData, ThrowOnError>): RequestResult<GetVoicemailGetCountsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetVoicemailGetCountsResponses, unknown, ThrowOnError>({ url: '/voicemail/counts', ...options });
    }
    
    public static deleteVoicemailDeleteMessage<ThrowOnError extends boolean = false>(options: Options<DeleteVoicemailDeleteMessageData, ThrowOnError>): RequestResult<DeleteVoicemailDeleteMessageResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteVoicemailDeleteMessageResponses, unknown, ThrowOnError>({ url: '/voicemail/{extensionId}/{id}', ...options });
    }
    
    public static putVoicemailUpdateFlag<ThrowOnError extends boolean = false>(options: Options<PutVoicemailUpdateFlagData, ThrowOnError>): RequestResult<PutVoicemailUpdateFlagResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutVoicemailUpdateFlagResponses, unknown, ThrowOnError>({
            url: '/voicemail/{extensionId}/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getVoicemailGetAudio<ThrowOnError extends boolean = false>(options: Options<GetVoicemailGetAudioData, ThrowOnError>): RequestResult<GetVoicemailGetAudioResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetVoicemailGetAudioResponses, unknown, ThrowOnError>({ url: '/voicemail/{extensionId}/{id}/audio', ...options });
    }
    
    /**
     * Service-only media stream used by Nexus for the *97*98 desk-phone mailbox.
     */
    public static getVoicemailGetInternalAudio<ThrowOnError extends boolean = false>(options: Options<GetVoicemailGetInternalAudioData, ThrowOnError>): RequestResult<GetVoicemailGetInternalAudioResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetVoicemailGetInternalAudioResponses, unknown, ThrowOnError>({ url: '/voicemail/internal/media/{id}/audio', ...options });
    }
    
    public static getVoicemailGetTranscription<ThrowOnError extends boolean = false>(options: Options<GetVoicemailGetTranscriptionData, ThrowOnError>): RequestResult<GetVoicemailGetTranscriptionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetVoicemailGetTranscriptionResponses, unknown, ThrowOnError>({ url: '/voicemail/{extensionId}/{id}/transcription', ...options });
    }
}
